import React, { useMemo } from 'react';
import {
  Steps,
  Button,
  Card,
  Typography,
  Switch,
  Row,
  Col,
  Pagination,
  Input,
  Checkbox,
  Divider,
  Modal,
  Select,
  Drawer,
} from 'antd';
import { emptyDatesObject } from '../../../availability_calendar/AvailabilityCalendar';
import { languages } from '../QuoteBooking';
import {
  DollarOutlined,
  EnvironmentOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons';
import calendarIcon from './images/calendar 44.svg';
import summaryIcon from './images/detail.svg';
import mainlake from './images/exotic_main_lake.png';
import countryCodes from '../../assets/data/iso3166_country_codes';

import './styles.css';
import { Collapse } from 'react-collapse';
import { useState } from 'react';
import tick from './images/check 1.svg';
import bedIcon from './images/bed 1.svg';
import globeIcon from './images/globe 1.svg';
import boxIcon from './images/box 1.svg';
import fishIcon from './images/fishing 1.svg';
import userIcon from './images/user 1.svg';
import taxiIcon from './images/frontal-taxi-cab 1.svg';
import cross from './images/close 1.svg';
import { ProductItem } from './ProductItem';

import { useEffect } from 'react';
import { StepProgress } from './StepProgress';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import SelectDate from './SelectDate';
import FishingSection from './FishingSection';
import { useReducer } from 'react';

import dayjs from 'dayjs';
import { useGlobalState } from './GlobalState';
import { DatePicker } from '@mui/x-date-pickers';
import { useUpdateReservationCostMutation } from '../../../admin/components/reservations/reservationSlice';
import { usePostReservationBookingMutation } from '../../../admin/components/quote/membersSlice';
import { notification } from '../../../../utils/messaging';
import { useGetLakeswithTypesQuery } from '../../../admin/components/settings/settingsSlice';
import { useHistory, useParams } from 'react-router';
import {
  useGetAddOnsQuery,
  useGetCustomPropertiesQuery,
} from '../../../admin/components/bookings/bookingSlice';
import {
  useGetAllPackagesQuery,
  useGetConvertedCurrencyMutation,
  useGetCurrencyListQuery,
  useGetPackagesDetailsByIdQuery,
} from '../packageSlice';
import PaymentPage from '../../components/payment_page/PaymentPage';
import { useGetFisheryQuery } from '../../../fishery_profile/fisherySlice';
import moment from 'moment';
import Moment from 'moment';
import BookingSuccessScreen from '../../components/booking_success/components/BookingSuccessScreen';
import PaymentFailure from '../../components/payment_page/PaymentFailure';
import { useGetUserQuery } from '../../../user_profile/userProfileSlice';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { includes } from 'lodash';
import ukFlag from '../assets/flags/united-kingdom 1.svg';
import { languageTranslation } from '../../../../lang';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const initialState = {
  accomodation: {
    include: '',
    guests: { adults: 0, children: 0, teen: 0 },
    rooms: [],
    completed: false,
  },
  fishing: {
    include: '',
    lake: '',
    angler: 0,
    swims: 0,
    guests: 0,
    fishing_days: 0,
    dates: [],
    completed: false,
  },
  taxi: {
    include: '',
    pickupDateTime: null,
    pickupLocation: '',
    dropoffDateTime: null,
    dropoffLocation: '',
    infoNotAvailable: false,
    completed: false,
  },
  add_ons: {
    include: '',
    user_amount: 0,
    completed: false,
  },
  guest_details: {
    title: '',
    nationality: '',
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    notes: '',
    terms: false,
    price_terms: false,
    completed: false,
  },
};

function reducer(state, action) {
  if (action.type === 'RESET') {
    return initialState;
  }
  if (action.section === null && typeof action.value === 'object') {
    return {
      ...state,
      ...action.value,
    };
  }
  if (action.path) {
    const keys = action.path.split('.');
    const newState = { ...state };
    let curr = newState;
    for (let i = 0; i < keys.length - 1; i++) {
      curr[keys[i]] = { ...curr[keys[i]] };
      curr = curr[keys[i]];
    }
    curr[keys[keys.length - 1]] = action.value;
    return newState;
  }
  return {
    ...state,
    [action.section]: { ...state[action.section], ...action.value },
  };
}
const { Option } = Select;
const PackageBooking = () => {
  const history = useHistory();
  const fisheryId = useParams()['fishery_id'];
  const packageId = useParams()['package_id'];

  const { data: packages } = useGetPackagesDetailsByIdQuery(
    { fishery_id: fisheryId, package_id: packageId },
    {
      skip: !fisheryId || !packageId,
    }
  );

  const { data: fisheryData } = useGetFisheryQuery(fisheryId);

  const [current, setCurrent] = useState('booking');
  const [currency, setCurrency] = useState();
  const [reservationExpiryTime, setReservationExpiryTime] = useState();
  const [bookingData, setBookingData] = useState(null);
  const [paymentFailureData, setPaymentFailureData] = useState(null);
  const [collapseVisible, setCollapseVisible] = useState('accomodation');
  const [cartItems, setCartItems] = useState([]);

  const [addedItems, setAddedItems] = useState([]);
  const [cost, setCost] = useState();
  const [convertedCost, setConvertedCost] = useState({
    totalPrice: 0,
    deposit: 0,
  });
  const [language, setLanguage] = useState('en-GB');
  const [showlanguageChange, setShowLanguageChange] = useState(false);
  //   const [isOverlayActive, setOverlayActive] = useState(true);
  const [accommodationBookingDates, setAccommodationBookingDates] = useState([
    { ...emptyDatesObject },
  ]);
  const [packageData, setPackageData] = useGlobalState('packageData');
  const [total, setTotal] = useState(0);
  const [isTaxi, setIsTaxi] = useState('yes');
  const [isPackage, setIsPackage] = useState('no');
  const [isDropoffTaxi, setIsDropoffTaxi] = useState('yes');
  const [showSummary, setShowSummary] = useState(false);
  const [calendarKey, setCalendarKey] = useGlobalState(
    'accommodationCalendarKey'
  );

  useEffect(() => {
    if (packages) setPackageData(packages?.[0]);
  }, [packages]);

  const { data: lakes } = useGetLakeswithTypesQuery(fisheryId);
  const [formData, dispatch] = useReducer(reducer, initialState);
  const [customPropertyDetails, setCustomPropertyDetails] = useGlobalState(
    'customPropertyDetails'
  );

  const handleSetValue = (section, value) => {
    dispatch({ section, value: { include: value } });
  };

  const handleChange = (pathOrSection, value) => {
    if (pathOrSection.includes('.')) {
      dispatch({ path: pathOrSection, value });
    } else {
      dispatch({ section: pathOrSection, value });
    }
  };
  const countCompletedSections = Object.values(formData).filter(
    (section) => section && section.completed === true
  ).length;

  const renderOptions = (section) => {
    return ['yes', 'no'].map((opt) => (
      <div
        key={opt}
        onClick={() => {
          if (opt === 'yes') {
            if (formData[section]?.include == 'no') {
              if (
                !(
                  section === 'add_ons' &&
                  packageData &&
                  !packageData.add_ons?.add_on_details?.length
                )
              ) {
                handleChange(section, {
                  completed: false,
                });
              }
            }
            if (section === 'add_ons') {
              if (packageData && !packageData.add_ons?.add_on_details?.length) {
                return;
              }
            }
            if (section === 'taxi') {
              setIsTaxi('yes');
              setIsDropoffTaxi('yes');
              if (accommodationBookingDates?.[0]?.endDate) {
                const dateWith7PM = dayjs(accommodationBookingDates[0].endDate)
                  .hour(19)
                  .minute(0)
                  .second(0);
                handleChange(
                  'taxi.dropoffDateTime',
                  dateWith7PM.format('YYYY-MM-DD HH:mm')
                );
              }
              if (accommodationBookingDates?.[0]?.startDate) {
                const dateWith7AM = dayjs(
                  accommodationBookingDates[0].startDate
                )
                  .hour(7)
                  .minute(0)
                  .second(0);
                handleChange(
                  'taxi.pickupDateTime',
                  dateWith7AM.format('YYYY-MM-DD HH:mm')
                );
              }
            }
            handleChange('taxi.infoNotAvailable', false);
            handleSetValue(section, opt);
            setCollapseVisible(section);
          } else {
            setCollapseVisible('');
            if (section === 'accomodation') {
              if (!packageData?.has_accommodation) {
                const rooms = AccommodationLake.booking_types.map((type) => ({
                  product_id: type.id,
                  max_occupancy: type?.max_occupancy,
                  capacity: type?.capacity,
                  name: type.name,
                  quantity: 0,
                }));
                handleChange('accomodation', {
                  include: 'no',
                  guests: { adults: 0, children: 0, teen: 0 },
                  rooms: rooms,
                  completed: true,
                });
                setAccommodationBookingDates([{ ...emptyDatesObject }]);
                if (formData?.fishing?.include !== 'no') {
                  setCollapseVisible('fishing');
                  handleChange('fishing.include', 'yes');
                } else if (
                  formData?.fishing?.include === 'no' &&
                  formData?.taxi?.include === 'yes'
                ) {
                  setCollapseVisible('taxi');
                } else {
                  setCollapseVisible('');
                }
                handleSetValue(section, opt);
              }
            } else if (section === 'fishing') {
              if (!packageData?.supports_fishing) {
                handleChange('fishing', {
                  lakes: '',
                  angler: 0,
                  swims: 0,
                  fishing_days: 0,
                  completed: true,
                });
                setCollapseVisible('');
                if (formData?.taxi?.include !== 'no') {
                  setCollapseVisible('taxi');
                  handleChange('taxi.include', 'yes');
                } else {
                  handleChange('taxi.completed', true);
                  if (formData?.add_ons?.include !== 'no') {
                    setCollapseVisible('add_ons');
                    handleChange('add_ons.include', 'yes');
                  } else {
                    handleChange('add_ons.completed', true);
                    setCollapseVisible('guest_details');
                  }
                }
                handleSetValue(section, opt);
              }
            } else if (section === 'taxi') {
              handleChange('taxi', {
                pickupDateTime: null,
                pickupLocation: '',
                dropoffDateTime: null,
                dropoffLocation: '',
                infoNotAvailable: false,
                completed: true,
              });
              setIsDropoffTaxi(false);
              setIsTaxi(false);
              handleSetValue(section, opt);
              setCollapseVisible('');
              if (formData?.add_ons?.include !== 'no') {
                setCollapseVisible('add_ons');
                handleChange('add_ons.include', 'yes');
              } else {
                handleChange('add_ons.completed', true);
                setCollapseVisible('guest_details');
              }
            } else if (section === 'add_ons') {
              const updatedArray = cartItems?.map((item) => {
                return {
                  ...item,
                  quantity: 0,
                };
              });

              setCartItems(updatedArray);
              setAddedItems([]);
              setCollapseVisible('guest_details');
              handleSetValue(section, opt);
              handleChange('add_ons', {
                completed: true,
              });
            }
          }
          // handleSetValue(section, opt);
        }}
        className='gSemiBold'
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          padding: '4px 8px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '14px',
        }}
      >
        <div
          style={{
            width: 20,
            height: 20,
            borderRadius: 4,
            background:
              formData[section].include === opt
                ? opt === 'yes'
                  ? '#249968'
                  : '#B22727'
                : '#EAEAEA',
          }}
          className='center justify-center'
        >
          <img alt='viewIcon' src={opt === 'yes' ? tick : cross} />
        </div>
        {activeLanguage?.reservation?.[opt]}
      </div>
    ));
  };

  const AccommodationLake = lakes?.find(
    (lake) => lake?.lake_type === 'accommodation'
  );
  let taxiDisabled =
    !formData?.taxi?.infoNotAvailable &&
    (!formData?.taxi?.pickupDateTime ||
      !formData?.taxi?.pickupLocation ||
      !formData?.taxi?.dropoffDateTime ||
      !formData?.taxi?.dropoffLocation);
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  let guestDisabled =
    !formData?.guest_details?.first_name ||
    !formData?.guest_details?.last_name ||
    !formData?.guest_details?.email ||
    !isValidEmail(formData?.guest_details?.email); // ⬅️ Email format check

  useEffect(() => {
    if (guestDisabled) {
      dispatch({
        section: 'guest_details',
        value: { completed: false },
      });
    }
  }, [guestDisabled]);
  useEffect(() => {
    setTimeout(() => {
      setCurrency('GBP');
      setCurrencySymbol(CurrencyList.find((i) => i.code === 'GBP')?.symbol);
    }, 1000);
  }, []);
  const { data: reservation, isLoading: packagesLoading } =
    useGetAllPackagesQuery(fisheryId, {
      skip: !fisheryId,
    });
  const { data: ProductsData } = useGetAddOnsQuery(
    {
      fisheryId: fisheryId,
      lakeId: [
        formData?.accomodation?.include === 'yes'
          ? AccommodationLake?.lake_id
          : null,
        formData?.fishing?.lake,
      ]
        .filter(Boolean)
        .join(','),
    },
    { skip: !fisheryId }
  );

  const { data: customProperties } = useGetCustomPropertiesQuery(
    {
      fisheryId: fisheryId,
      online: true,
      lakeId: [
        formData?.accomodation?.include === 'yes'
          ? AccommodationLake?.lake_id
          : null,
        formData?.fishing?.lake,
      ]
        .filter(Boolean)
        .join(','),
    },
    {
      skip: !fisheryId,
    }
  );
  useEffect(() => {
    let updatedProperties = customProperties?.map((item) => {
      const existingItem = customPropertyDetails?.find(
        (detail) => detail.field_name === item.field_name
      );

      return {
        ...item,
        field_value: existingItem ? existingItem.field_value : '',
      };
    });

    setCustomPropertyDetails(updatedProperties);
  }, [customProperties]);
  const hasAddonQuantity = addedItems.some((item) => item.quantity > 0);
  const allCompleted = Object.values(formData).every(
    (section) => section?.completed === true
  );

  useEffect(() => {
    if (AccommodationLake?.booking_types && !packageData) {
      const rooms = AccommodationLake.booking_types.map((type) => ({
        product_id: type.id,
        max_occupancy: type.max_occupancy,
        capacity: type.capacity,
        name: type.name,
        quantity: 0,
      }));
      dispatch({
        section: 'accomodation',
        value: { include: 'yes', rooms: rooms },
      });
      setCollapseVisible('accomodation');
    }
  }, [lakes]);

  const handleRoomChange = (product_id, delta) => {
    const adults = formData.accomodation.guests.adults;
    const minRooms = Math.ceil(adults / 2);
    const maxRooms = adults;

    const updatedRooms = formData.accomodation.rooms.map((room) => {
      if (room.product_id === product_id) {
        const newQuantity = room.quantity + delta;

        // Prevent negative room quantity
        return {
          ...room,
          quantity: Math.max(0, newQuantity),
        };
      }
      return room;
    });

    const newTotal = updatedRooms.reduce((sum, room) => sum + room.quantity, 0);

    // Apply only if total rooms stay within valid range
    if (newTotal <= maxRooms) {
      dispatch({
        section: 'accomodation',
        value: { rooms: updatedRooms, completed: false },
      });

      setAccommodationBookingDates([{ ...emptyDatesObject }]);
    }
  };

  const handleGuestChange = (type, delta) => {
    const newGuests = {
      ...formData.accomodation.guests,
      [type]: Math.max(0, formData.accomodation.guests[type] + delta),
    };
    dispatch({ section: 'accomodation', value: { guests: newGuests } });
    setAccommodationBookingDates([{ ...emptyDatesObject }]);
  };
  const formatDatesByMonth = (dates) => {
    const suffix = (d) => {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    };

    const sortedDates = dates.map((d) => dayjs(d)).sort((a, b) => a - b);

    const grouped = {};

    sortedDates.forEach((date) => {
      if (dayjs(date).isValid()) {
        const month = date.format('MMMM');
        const day = dayjs(date).isValid()
          ? `${date.date()}${suffix(date.date())}`
          : '';
        if (!grouped[month]) grouped[month] = [];
        grouped[month].push(day);
      }
    });

    return Object.entries(grouped)
      .map(([month, days]) => `${days.join(', ')} ${month}`)
      .join(' - ');
  };

  const start = accommodationBookingDates?.[0]?.startDate;
  const end = accommodationBookingDates?.[0]?.endDate;
  const accommodation_days =
    start && end ? Math.max(1, dayjs(end).diff(dayjs(start), 'day')) : 0;
  const totalRooms = formData.accomodation.rooms.reduce(
    (sum, room) => sum + room.quantity,
    0
  );
  const totalPeopleAllowed = formData?.accomodation?.rooms?.reduce(
    (total, room) => {
      return total + room.max_occupancy * room.quantity;
    },
    0
  );
  const minRooms = Math.ceil(formData.accomodation.guests.adults / 2);
  const maxRooms = formData.accomodation.guests.adults;
  const [getCost] = useUpdateReservationCostMutation();
  const [convertCurrency] = useGetConvertedCurrencyMutation();
  const [postBooking, { isLoading: postLoading }] =
    usePostReservationBookingMutation();

  const updateCost = () => {
    let payload = {
      lake_id: formData?.fishing?.lake ?? '',
      package_id: packageData?.id ?? '',
      accommodation_lake_id:
        formData.accomodation.include === 'yes'
          ? AccommodationLake?.lake_id
          : '',
      taxi_information: {
        taxi_booked: formData?.taxi?.include === 'yes',
        pickup_date: formData?.taxi?.pickupDateTime || '',
        pickup_taxi: isTaxi === 'yes',
        dropoff_taxi: isDropoffTaxi === 'yes',
        pickup_location: formData?.taxi?.pickupLocation || '',
        dropoff_date: formData?.taxi?.dropoffDateTime || '',
        dropoff_location: formData?.taxi?.dropoffLocation || '',
      },
      accommodation: formData.accomodation.include === 'yes',
      accommodation_users: {
        no_of_adults: formData.accomodation.include
          ? formData.accomodation?.guests?.adults ?? 0
          : 0,
        no_of_children: formData.accomodation.include
          ? formData.accomodation?.guests?.children ?? 0
          : 0,
        no_of_teens: formData.accomodation.include
          ? formData.accomodation?.guests?.teen ?? 0
          : 0,
      },
      accommodation_days: accommodation_days,
      accommodation_details: formData.accomodation.rooms
        .filter((room) => room.quantity > 0)
        .map((room) => ({
          ticket_type_id: room.product_id,
          quantity: room.quantity,
          arrival_date:
            (accommodationBookingDates?.[0]?.startDate &&
              dayjs(accommodationBookingDates?.[0]?.startDate).isValid() &&
              dayjs(accommodationBookingDates?.[0]?.startDate).format(
                'YYYY-MM-DD'
              )) ||
            '',
          departure_date:
            (accommodationBookingDates?.[0]?.endDate &&
              dayjs(accommodationBookingDates?.[0]?.endDate).isValid() &&
              dayjs(accommodationBookingDates?.[0]?.endDate).format(
                'YYYY-MM-DD'
              )) ||
            '',
        })),
      arrival_timestamp:
        (accommodationBookingDates?.[0]?.startDate &&
          dayjs(accommodationBookingDates?.[0]?.startDate).isValid() &&
          dayjs(accommodationBookingDates?.[0]?.startDate).format(
            'YYYY-MM-DD'
          )) ||
        '',
      departure_timestamp:
        (accommodationBookingDates?.[0]?.endDate &&
          dayjs(accommodationBookingDates?.[0]?.endDate).isValid() &&
          dayjs(accommodationBookingDates?.[0]?.endDate).format(
            'YYYY-MM-DD'
          )) ||
        '',
      fishing_days: formData?.fishing?.dates ?? [],
      fishing: Boolean(formData.fishing.lake),
      num_anglers: formData.fishing.angler || 0,
      num_swims: formData.fishing.swims || 0,
      num_guests: formData.fishing.guests || 0,
      num_fishing_days: formData.fishing.fishing_days || 0,
      angler_details: [
        {
          first_name: formData.guest_details.first_name || '',
          last_name: formData.guest_details.last_name || '',
          email: formData.guest_details.email || '',
          phone_number: formData.guest_details.phone_number || '',
        },
      ],
      booking_type: '',
      apply_promotion: false,
      add_on_details: (addedItems || [])
        .filter((addOn) => addOn.quantity > 0)
        .map((addOn) => ({
          product_id: addOn.product_id,
          quantity: addOn.quantity,
        })),
      custom_slot_id: '',
    };
    getCost(payload)
      .unwrap()
      .then((v) => {
        setCost(v);
      });
  };
  useEffect(() => {
    if (cost?.pricing_details?.pricing_breakdown?.advance_price) {
      convertCurrency({
        amount: cost?.pricing_details?.pricing_breakdown?.advance_price,
        currency_from: fisheryData?.currency,
        currency_to: currency,
      })
        .unwrap()
        .then((v) => {
          setConvertedCost((prev) => ({
            ...prev,
            deposit: v,
          }));
        });
    }
    if (cost?.pricing_details?.pricing_breakdown?.total_price) {
      convertCurrency({
        amount: cost?.pricing_details?.pricing_breakdown?.total_price,
        currency_from: fisheryData?.currency,
        currency_to: currency,
      })
        .unwrap()
        .then((v) => {
          setConvertedCost((prev) => ({
            ...prev,
            totalPrice: v,
          }));
        });
    }
  }, [cost, currency]);

  let CurrencyList = [
    { code: 'GBP', name: 'British Pound Sterling', symbol: '£' },
    { code: 'EUR', name: 'Euro', symbol: '€' },
    { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$' },
    { code: 'USD', name: 'United States Dollar', symbol: '$' },
    { code: 'JPY', name: 'Japanese Yen', symbol: '¥' },
    { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$' },
    { code: 'AUD', name: 'Australian Dollar', symbol: 'A$' },
    { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$' },
    { code: 'CNY', name: 'Chinese Yuan', symbol: '¥' },
    { code: 'MYR', name: 'Malaysian Ringgit', symbol: 'RM' },
    { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$' },
    { code: 'THB', name: 'Thai Baht', symbol: '฿' },
  ];
  const languageOptions = languages?.map(({ code, name, flag }) => ({
    label: (
      <span>
        <span>
          <img src={flag} width={14} alt='' className='mg-right-5' />
        </span>
        <span className='txt-underline sb-blue-500'>{name}</span>
      </span>
    ),
    value: code,
  }));
  const [currencySymbol, setCurrencySymbol] = useState('');
  // useEffect(() => {
  //   setCurrency(fisheryData?.currency);
  //   setCurrencySymbol(
  //     CurrencyList.find((i) => i.code === fisheryData?.currency)?.symbol
  //   );
  // }, [fisheryData]);

  const countryOptions = CurrencyList?.sort(({ code: x }, { code: y }) =>
    x === 'GBP' ? -1 : y === 'GBP' ? 1 : 0
  )?.map(({ code, name }) => ({
    label: (
      <span>
        {name} ({code})
      </span>
    ),
    value: code,
  }));
  const ResetValue = () => {
    const rooms = AccommodationLake?.booking_types.map((type) => {
      return {
        product_id: type.id,
        name: type.name,
        max_occupancy: type?.max_occupancy,
        capacity: type?.capacity,
        quantity: 0,
      };
    });
    setPackageData(null);
    setAccommodationBookingDates([{ ...emptyDatesObject }]);
    setAddedItems([]);

    dispatch({
      section: null,
      value: {
        accomodation: {
          include: 'no',
          rooms: rooms || [],
          guests: {
            adults: 0,
            children: 0,
            teen: 0,
          },
          completed: false,
        },
        fishing: {
          include: 'no',
          fishing_days: 0,

          lake: '',
          angler: 0,
          swims: 0,
          guests: 0,
          dates: [],
          completed: false,
        },
        taxi: {
          include: 'no',
        },
        add_ons: {
          include: 'no',
        },
      },
    });
  };
  useEffect(() => {
    if (!packageData) return;

    const {
      lake_id,
      has_accommodation,
      no_of_rooms,
      supports_fishing,
      number_of_fishing_days,
      package_occupants,
      add_ons,
      included_benefits,
    } = packageData;

    const rooms = AccommodationLake?.booking_types.map((type) => {
      const matchedRoom = no_of_rooms?.find(
        (r) => r.ticket_type_id === type.id
      );
      return {
        product_id: type.id,
        name: type.name,
        max_occupancy: type?.max_occupancy,
        capacity: type?.capacity,
        quantity: matchedRoom?.quantity > 0 ? matchedRoom.quantity : 0,
      };
    });

    // Prepare add-ons data
    const addOnDetails = add_ons?.add_on_details?.map((addOn) => ({
      product_id: addOn.product_id,
      name: addOn.name,
      quantity: addOn.quantity || 0,
      price: addOn.price,
    }));
    const hasPickupOrDropoff = included_benefits.some(
      (item) =>
        (item.label === 'Pickup Included' ||
          item.label === 'Dropoff Included') &&
        item.selected
    );
    dispatch({
      section: null,
      value: {
        accomodation: {
          include: has_accommodation ? 'yes' : 'no',
          rooms: rooms || [],
          guests: {
            adults: package_occupants.adults,
            children: package_occupants.children,
            teen: package_occupants.teens || 0,
          },
          completed: !has_accommodation,
        },
        fishing: {
          include: supports_fishing ? 'yes' : 'no',
          fishing_days: number_of_fishing_days,

          lake: lake_id,
          angler: packageData?.fishing_details?.no_of_anglers,
          swims: packageData?.fishing_details?.no_of_swims,
          guests: 0,
          dates: [],
          completed: !supports_fishing,
        },
        taxi: {
          include: hasPickupOrDropoff ? 'yes' : 'no',
        },
        add_ons: {
          include: addOnDetails?.length ? 'yes' : 'no',
        },
      },
    });
    if (hasPickupOrDropoff) {
      setIsDropoffTaxi('yes');
      setIsTaxi('yes');
    }
    if (packageData?.id !== '') {
      setIsPackage('yes');
      if (has_accommodation) {
        setCollapseVisible('accomodation');
      } else if (supports_fishing) {
        setCollapseVisible('fishing');
      }
    } else {
      setPackageData(null);
      setIsPackage('no');
    }
  }, [packageData, AccommodationLake]);
  useEffect(() => {
    if (
      formData?.fishing?.swims > 0 ||
      formData?.fishing?.fishing_days > 0 ||
      dayjs(accommodationBookingDates?.[0]?.startDate).isValid() ||
      dayjs(accommodationBookingDates?.[0]?.endDate).isValid()
    ) {
      updateCost();
    }
  }, [
    formData?.fishing?.angler,
    formData?.fishing?.swims,
    formData?.fishing?.guests,
    formData?.fishing?.fishing_days,
    addedItems,
    formData?.accomodation?.completed,
    formData?.taxi?.completed,
    accommodationBookingDates?.[0]?.startDate,
    accommodationBookingDates?.[0]?.endDate,
  ]);
  useEffect(() => {
    if (formData?.taxi?.include === 'no') {
      updateCost();
    }
  }, [formData?.taxi?.include]);
  useEffect(() => {
    if (!packageData) {
      handleChange('fishing', {
        lake: '',
        swims: 0,
        angler: 0,
        fishing_days: 0,
        dates: [],
      });
    }
  }, [formData?.accomodation?.include]);

  const postBookingRequest = () => {
    let payload = {
      arrival_timestamp: '',
      departure_timestamp: '',

      anglers: formData?.fishing?.angler || 0,
      accommodation_users: {
        no_of_adults: formData.accomodation.include
          ? formData.accomodation?.guests?.adults ?? 0
          : 0,
        no_of_children: formData.accomodation.include
          ? formData.accomodation?.guests?.children ?? 0
          : 0,
        no_of_teens: formData.accomodation.include
          ? formData.accomodation?.guests?.teen ?? 0
          : 0,
      },
      amount: cost?.pricing_details?.pricing_breakdown?.advance_price,
      total_price: cost?.pricing_details?.pricing_breakdown?.total_price,
      lake_id: formData?.fishing?.lake ?? '',
      accommodation_lake_id:
        formData.accomodation.include === 'yes'
          ? AccommodationLake?.lake_id
          : '',
      is_admin_booking_or_editing: false,
      swims: [],
      details: {
        angler_details: [
          {
            first_name: formData?.guest_details?.first_name || '',
            title: formData?.guest_details?.title || '',
            nationality: formData?.guest_details?.nationality || '',
            last_name: formData?.guest_details?.last_name || '',
            email: formData?.guest_details?.email || '',
            phone_number: formData?.guest_details?.phone_number || '',
            note: formData?.guest_details?.notes || '',
          },
        ],
      },
      payment_type: '',
      book_lake_exclusive: false,
      use_wallet: false,
      wallet_amount_to_spend: 0,
      add_on_details: addedItems?.filter((item) => item.quantity > 0) || [],
      type: 'package',
      package_id: packageId,
      has_accommodation: formData?.accomodation?.include === 'yes',
      accommodation_details:
        formData?.accomodation?.rooms
          ?.filter((room) => room.quantity > 0)
          ?.map((room) => ({
            ticket_type_id: room.product_id,
            ticket_type_name: room.name,
            quantity: room.quantity,
            arrival_date:
              (accommodationBookingDates?.[0]?.startDate &&
                dayjs(accommodationBookingDates?.[0]?.startDate).isValid() &&
                dayjs(accommodationBookingDates?.[0]?.startDate).format(
                  'YYYY-MM-DD'
                )) ||
              '',
            departure_date:
              (accommodationBookingDates?.[0]?.endDate &&
                dayjs(accommodationBookingDates?.[0]?.endDate).isValid() &&
                dayjs(accommodationBookingDates?.[0]?.endDate).format(
                  'YYYY-MM-DD'
                )) ||
              '',
          })) || [],
      supports_fishing: formData?.fishing?.include === 'yes',
      custom_properties: customPropertyDetails,
      taxi_information: {
        taxi_booked: formData?.taxi?.include === 'yes',
        pickup_taxi: isTaxi === 'yes',
        dropoff_taxi: isDropoffTaxi === 'yes',
        pickup_date: formData?.taxi?.pickupDateTime || '',
        pickup_location: formData?.taxi?.pickupLocation || '',
        dropoff_date: formData?.taxi?.dropoffDateTime || '',
        no_info_yet: formData?.taxi?.infoNotAvailable,
        dropoff_location: formData?.taxi?.dropoffLocation || '',
      },
      fishing_details: {
        fishing_dates: formData?.fishing?.dates,
        number_of_fishing_days: formData?.fishing?.fishing_days || 0,
        number_of_swims: formData?.fishing?.swims || 0,
        number_of_guests: formData?.fishing?.guests || 0,
        number_of_anglers: formData.fishing?.angler ?? 0,
      },
    };

    postBooking(payload)
      .unwrap()
      .then((v) => {
        setBookingData(v);
        setReservationExpiryTime(Moment(moment.now()).add(15, 'minutes'));
        setCurrent('payment');
      });
  };

  useEffect(() => {
    const updateCartItemsWithCurrency = async () => {
      if (!ProductsData?.length || !currency || !fisheryData?.currency) return;

      const addOnDetails = packageData?.add_ons?.add_on_details ?? [];

      const filteredAddedItems = addedItems.filter((addOn) =>
        ProductsData.some((product) => product.id === addOn.product_id)
      );
      const updatedCart = await Promise.all(
        ProductsData.map(async (product) => {
          const matchingAddOn = addOnDetails.find(
            (a) => a.product_id === product.id
          );
          const matchingCartItem = cartItems.find((a) => a.id === product.id);

          let convertedAmount = null;
          try {
            const conversion = await convertCurrency({
              amount: product?.price,
              currency_from: fisheryData.currency,
              currency_to: currency,
            }).unwrap();
            convertedAmount = conversion;
          } catch (error) {
            console.error(
              `Failed to convert currency for product ${product.id}:`,
              error
            );
          }

          return {
            ...product,
            quantity:
              matchingAddOn?.quantity || matchingCartItem?.quantity || 0,
            currency,
            convertedAmount,
          };
        })
      );

      setCartItems(updatedCart);
      setAddedItems(addOnDetails.length ? addOnDetails : filteredAddedItems);
    };

    updateCartItemsWithCurrency();
  }, [ProductsData, packageData, currency]);

  const handleIncrease = (itemId, quantity, maxQuantity) => {
    if (!maxQuantity || quantity < maxQuantity) {
      setCartItems((prevItems) =>
        prevItems.map((item) =>
          item.id === itemId ? { ...item, quantity: item.quantity + 1 } : item
        )
      );

      setAddedItems((prevAddedItems) => {
        const existingItem = prevAddedItems.find(
          (item) => item.product_id === itemId
        );

        if (existingItem) {
          return prevAddedItems.map((item) =>
            item.product_id === itemId
              ? {
                  ...(item?.name && { name: item?.name }),
                  ...(item?.price && { price: item?.price }),
                  product_id: item.product_id,

                  quantity: item.quantity + 1,
                }
              : item
          );
        } else {
          const newItem = cartItems.find((item) => item.id === itemId);
          return [
            ...prevAddedItems,
            {
              ...(newItem?.name && { name: newItem?.name }),
              ...(newItem?.price && { price: newItem?.price }),
              product_id: newItem?.id,
              quantity: 1,
            },
          ];
        }
      });
    }
  };

  const handleDecrease = (itemId, quantity) => {
    if (quantity > 0) {
      setCartItems((prevItems) =>
        prevItems.map((item) =>
          item.id === itemId && item.quantity > 0
            ? { ...item, quantity: item.quantity - 1 }
            : item
        )
      );

      setAddedItems((prevAddedItems) => {
        const existingItem = prevAddedItems.find(
          (item) => item.product_id === itemId
        );

        if (existingItem && existingItem.quantity > 1) {
          return prevAddedItems.map((item) =>
            item.product_id === itemId
              ? {
                  ...(item?.name && { name: item?.name }),
                  ...(item?.price && { price: item?.price }),
                  quantity: item.quantity - 1,
                  product_id: item.product_id,
                }
              : item
          );
        } else {
          return prevAddedItems.filter((item) => item.product_id !== itemId);
        }
      });
    }
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [packageCurrentPage, setPackageCurrentPage] = useState(1);
  const onChangePagination = (page) => {
    setCurrentPage(page);
  };
  const startIndex = (currentPage - 1) * 8;
  const endIndex = startIndex + 8;
  const packageStartIndex = (packageCurrentPage - 1) * 6;
  const packageEndIndex = packageStartIndex + 6;
  const totalRoomsBooked = formData.accomodation.rooms.reduce(
    (acc, room) => acc + room.quantity,
    0
  );
  let isOverlayActive =
    !packageId &&
    !packageData?.id &&
    (formData?.accomodation?.guests?.adults == 0 ||
      totalRoomsBooked == 0 ||
      formData?.accomodation?.guests?.adults > totalPeopleAllowed ||
      totalRooms > maxRooms);
  const resetData = () => {
    dispatch({ type: 'RESET' });
    setPackageData(null);
    setAccommodationBookingDates([{ ...emptyDatesObject }]);
    setAddedItems([]);
  };
  const activeLanguage = languageTranslation[language];
  const SummaryContent = (
    <>
      <div
        level={4}
        className='container-heading sb-blue-bg-700 white gSemiBold fs-20'
      >
        <div className='row-center'>
          <img src={summaryIcon} className='mg-right-10' alt='calendar' />
          {activeLanguage?.quote_summary?.summary}
        </div>
      </div>
      <div className='pd-15 justify-between center details-container w-full'>
        <div className='summary-container'>
          {/* Image Section */}
          <div className='summary-image'>
            <img src={mainlake} alt='Exotic Fishing Thailand' />
            <div className='summary-title'>Exotic Fishing Thailand</div>
          </div>

          {/* Details Section */}
          <div className='summary-details'>
            {/* Accommodation */}
            <Row className='summary-section gSemiBold sb-blue-900 '>
              <Col
                span={24}
                className='row-center justify-between mg-bottom-15 fs-16 '
              >
                <div>
                  {activeLanguage?.quote_summary?.accommodation_included}:
                </div>
                <div>
                  {formData?.accomodation?.include == 'yes'
                    ? activeLanguage?.reservation?.taxi?.yes
                    : activeLanguage?.reservation?.taxi?.no}
                </div>
              </Col>

              <Col className='details' span={12}>
                {activeLanguage?.quote_summary?.no_of_adults}:
              </Col>
              <Col span={12} className='summary-value details'>
                {formData?.accomodation?.guests?.adults}
              </Col>

              <Col className='details' span={12}>
                {activeLanguage?.quote_summary?.no_of_children}:
              </Col>
              <Col span={12} className='summary-value details'>
                {formData?.accomodation?.guests?.children}
              </Col>
              <Col className='details' span={12}>
                {activeLanguage?.quote_summary?.no_of_teens}:
              </Col>
              <Col span={12} className='summary-value details'>
                {formData?.accomodation?.guests?.teen}
              </Col>

              <Col className='details' span={12}>
                {activeLanguage?.quote_summary?.no_of_rooms}:
              </Col>
              <Col span={12} className='summary-value details'>
                {totalRoomsBooked}
              </Col>

              <Col className='details' span={12}>
                {activeLanguage?.quote_summary?.arrival_date}:
              </Col>
              <Col span={12} className='summary-value details'>
                {accommodationBookingDates?.[0]?.startDate &&
                  dayjs(accommodationBookingDates?.[0]?.startDate).format(
                    'DD/MM/YYYY'
                  )}
              </Col>

              <Col className='details' span={12}>
                {activeLanguage?.quote_summary?.departure_date}:
              </Col>
              <Col span={12} className='summary-value details'>
                {accommodationBookingDates?.[0]?.endDate &&
                  dayjs(accommodationBookingDates[0].endDate).isValid() &&
                  dayjs(accommodationBookingDates?.[0]?.endDate).format(
                    'DD/MM/YYYY'
                  )}
              </Col>
            </Row>

            {/* Fishing */}
            <Row className='summary-section gSemiBold sb-blue-900 '>
              <Col
                span={24}
                className='row-center justify-between mg-bottom-15 fs-16 '
              >
                <div>{activeLanguage?.quote_summary?.fishing_included}:</div>
                <div>
                  {formData?.fishing?.include == 'yes'
                    ? activeLanguage?.reservation?.taxi?.yes
                    : activeLanguage?.reservation?.taxi?.no}
                </div>
              </Col>
              <Col className='details' span={12}>
                {activeLanguage?.quote_summary?.no_of_anglers}:
              </Col>
              <Col span={12} className='summary-value details'>
                {formData?.fishing?.angler}
              </Col>

              <Col className='details' span={12}>
                {activeLanguage?.quote_summary?.no_of_swims}:
              </Col>
              <Col span={12} className='summary-value details'>
                {formData?.fishing?.swims}
              </Col>

              <Col className='details' span={12}>
                {activeLanguage?.quote_summary?.no_of_fishing_days}:
              </Col>
              <Col span={12} className='summary-value details'>
                {formData?.fishing?.fishing_days}
              </Col>

              <Col className='details' span={12}>
                {activeLanguage?.quote_summary?.fishing_dates}:
              </Col>
              <Col span={12} className='summary-value details'>
                {formatDatesByMonth(formData?.fishing?.dates)}
              </Col>
            </Row>

            <Row className='summary-section gSemiBold sb-blue-900 '>
              <Col
                span={24}
                className='row-center justify-between mg-bottom-15 fs-16 '
              >
                <div>{activeLanguage?.quote_summary?.taxis_included}:</div>
                <div>
                  {' '}
                  {formData?.taxi?.include == 'yes'
                    ? activeLanguage?.reservation?.taxi?.yes
                    : activeLanguage?.reservation?.taxi?.no}
                </div>
              </Col>
              <Col className='details' span={12}>
                {activeLanguage?.quote_summary?.pick_up_date_and_time}:
              </Col>
              <Col span={12} className='summary-value details'>
                {formData.taxi.pickupDateTime
                  ? dayjs(formData.taxi.pickupDateTime)
                      .add(30, 'minute') // Add 30 mins to decide rounding
                      .startOf('hour') // Round to nearest hour
                      .format('ha | DD/MM/YYYY')
                  : ''}
              </Col>

              <Col className='details' span={12}>
                {activeLanguage?.quote_summary?.pick_up_location}:
              </Col>
              <Col span={12} className='summary-value details'>
                {formData.taxi.pickupLocation}
              </Col>

              <Col className='details' span={12}>
                {activeLanguage?.quote_summary?.drop_off_date_and_time}:
              </Col>
              <Col span={12} className='summary-value details'>
                {formData.taxi.dropoffDateTime
                  ? dayjs(formData.taxi.dropoffDateTime).format(
                      'ha | DD/MM/YYYY'
                    )
                  : ''}
              </Col>

              <Col className='details' span={12}>
                {activeLanguage?.quote_summary?.drop_off_location}:
              </Col>
              <Col span={12} className='summary-value details'>
                {formData.taxi.dropoffLocation}
              </Col>
            </Row>

            {/* Add-ons */}
            <Row className='summary-section gSemiBold sb-blue-900 '>
              <Col
                span={24}
                className='row-center justify-between mg-bottom-15 fs-16 '
              >
                <div>{activeLanguage?.quote_summary?.add_ons}:</div>
                <div>
                  {' '}
                  {formData?.add_ons?.include == 'yes'
                    ? activeLanguage?.reservation?.taxi?.yes
                    : activeLanguage?.reservation?.taxi?.no}
                </div>
              </Col>
              {addedItems?.map((item, index) => (
                <Row key={index} className='w-full'>
                  <Col className='details' span={18}>
                    {item.name}
                  </Col>
                  <Col span={6} className='summary-value details'>
                    x{item.quantity}
                  </Col>
                </Row>
              ))}
            </Row>
          </div>
        </div>
        <div className='price-container'>
          <div className='price-section sb-blue-900 justify-between'>
            <div className='fs-20 gSemiBold'>
              {activeLanguage?.quote_summary?.total_price}:
            </div>
            <div className='row-center'>
              <div className='gSemiBold fs-14 mg-right-5'>
                ({currency} {currencySymbol})
              </div>
              <div
                className='seagreen-bg-700 br5 white fs-18 gSemiBold pd-left-5 pd-right-5 txt-right'
                style={{ minWidth: 100 }}
              >
                {convertedCost?.totalPrice ??
                  cost?.pricing_details?.pricing_breakdown?.total_price ??
                  0}
              </div>
            </div>
          </div>

          <div className='price-section sb-blue-900'>
            <div className='fs-20 gSemiBold center'>
              {activeLanguage?.quote_summary?.pay_today}:
              <div className='fs-12 gSemiBold'>
                ({activeLanguage?.quote_summary?.deposit_perc})
              </div>
            </div>
            <div className='row-center'>
              <div className='gSemiBold fs-14 mg-right-5'>
                ({currency} {currencySymbol})
              </div>
              <div
                className='seagreen-bg-500 br5 white txt-right fs-18 gSemiBold pd-left-5 pd-right-5'
                style={{ minWidth: 100 }}
              >
                {convertedCost?.deposit ??
                  cost?.pricing_details?.pricing_breakdown?.advance_price ??
                  0}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      {current === 'booking' && (
        <div>
          <Modal
            className='language_modal'
            open={showlanguageChange}
            width='min(40rem, 95%)'
            closable={false}
            maskClosable={false}
            centered
            destroyOnClose
            onOk={() => {}}
            onCancel={() => {
              setShowLanguageChange(false);
            }}
            footer=''
          >
            <>
              <div
                className='language_modal_title gSemiBold fs-18'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  paddingLeft: '24px',
                }}
              >
                <img
                  src={globeIcon}
                  alt='certificate'
                  style={{ width: '22px', height: '22px' }}
                />
                <span>Change Currency / Language</span>
              </div>
              <div style={{ padding: '16px 16px 0 16px', marginTop: '60px' }}>
                <div className='row-center gap-1r flex-wrap'>
                  <div className='row-center mg-right-0 w-full'>
                    <div
                      className='fs-13 gSemiBold grey-700 mg-right-10'
                      style={{ width: 65 }}
                    >
                      Language:
                    </div>
                    <Select
                      className='br5 mg-left-10 gBold currency-select w-full'
                      style={{ textAlign: 'left', flex: 1 }}
                      value={language}
                      onChange={(v) => {
                        setLanguage(v);
                      }}
                      popupClassName='gBold'
                      optionFilterProp='label'
                      options={languageOptions}
                    />
                  </div>
                  <div className='row-center  mg-right-0 w-full flex-wrap'>
                    <div
                      className='fs-13 gSemiBold grey-700 mg-right-10'
                      style={{ width: 60 }}
                    >
                      Currency:
                    </div>
                    <Select
                      className='br5 mg-left-10 gBold w-full  currency-select'
                      style={{ flex: 1 }}
                      value={currency}
                      onChange={(v) => {
                        setCurrency(v);
                        const selected = CurrencyList.find((c) => c.code === v);
                        if (selected) {
                          setCurrencySymbol(selected.symbol);
                        }
                      }}
                      optionFilterProp='label'
                      popupClassName='payment_form__selector'
                      options={countryOptions}
                    />
                  </div>
                </div>

                <Col span={24} className='mg-top-30'>
                  <div className=' w-full row-center gap-2r justify-end'>
                    <Button
                      className='gBold br8 fs-14 white txt-center sb-blue-bg-600 hover:sb-blue-bg-700 pd-10 '
                      style={{
                        width: 162,
                        maxWidth: '100%',
                        height: 'auto',
                      }}
                      onClick={() => {
                        setShowLanguageChange(false);
                      }}
                    >
                      Save Changes
                    </Button>
                  </div>
                </Col>
              </div>
            </>
          </Modal>

          <div className='container-user-reservation'>
            <div className='mg-auto' style={{ maxWidth: 1560 }}>
              <div
                style={{ margin: '20px 30px' }}
                className='row-center gap-1r flex-wrap language-select-desktop'
              >
                <div className='row-center mg-right-0'>
                  <div className='fs-13 gSemiBold grey-700 mg-right-10'>
                    Language:
                  </div>
                  <Select
                    className='br5 mg-left-10 gBold language-select'
                    style={{ width: 150, textAlign: 'left' }}
                    value={language}
                    onChange={(v) => {
                      setLanguage(v);
                    }}
                    popupClassName='gBold'
                    optionFilterProp='label'
                    options={languageOptions}
                  />
                </div>
                <div className='row-center  mg-right-20 flex-wrap'>
                  <div className='fs-13 gSemiBold grey-700 mg-right-10'>
                    Select Currency:
                  </div>
                  <Select
                    className='br5 mg-left-10 gBold currency-select'
                    style={{ width: 220 }}
                    value={currency}
                    onChange={(v) => {
                      setCurrency(v);
                      const selected = CurrencyList.find((c) => c.code === v);
                      if (selected) {
                        setCurrencySymbol(selected.symbol);
                      }
                    }}
                    optionFilterProp='label'
                    popupClassName='payment_form__selector'
                    options={countryOptions}
                  />
                </div>
              </div>
              <Row className='w-full justify-center mg-bottom-50 gap-1r'>
                {/* Left Panel */}
                <Col xs={24} sm={24} md={24} lg={16} className='left-panel'>
                  <div
                    level={4}
                    className='sb-blue-bg-700 white gSemiBold fs-20 container-heading  '
                  >
                    <div className='row-center'>
                      <img
                        src={calendarIcon}
                        className='mg-right-10'
                        alt='calendar'
                      />
                      {/* <div>New Reservation </div> */}
                      <div>{activeLanguage?.reservation?.new_reservation} </div>
                    </div>
                    <StepProgress
                      currentStep={countCompletedSections}
                      steps={[1, 2, 3, 4, 5]}
                    />
                  </div>
                  <div className='pd-20 justify-between details center w-full'>
                    <div className='w-full'>
                      <div
                        className='language-select-mobile'
                        onClick={() => {
                          setShowLanguageChange(true);
                        }}
                      >
                        <img
                          src={ukFlag}
                          alt='uk'
                          className='mg-right-10'
                          width={17}
                        />
                        Change Currency / Language
                      </div>
                      <div className='individual-container mg-bottom-10'>
                        <div
                          className='pd-20  cp'
                          onClick={() => {
                            if (isPackage === 'yes') {
                              setCollapseVisible('package');
                            }
                          }}
                        >
                          <div className='fs-18 row-center gSemiBold justify-between mg-bottom-0'>
                            <div className='row-center w-full justify-between flex-wrap gap-05r'>
                              <div className='row-center'>
                                <div
                                  className='sb-blue-bg-600 br5 center justify-center mg-right-10'
                                  style={{ minWidth: 34, height: 34 }}
                                >
                                  <img src={boxIcon} alt='bed-icon' />
                                </div>
                                <div className='row-center  justify-between'>
                                  <div className='fs-18 '>
                                    {activeLanguage?.reservation?.packages}
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  alignItems: 'center',
                                  gap: '8px',
                                }}
                              >
                                <span className='fs-14 gRegular'>
                                  {
                                    activeLanguage?.reservation
                                      ?.add_reservation_based_on_package
                                  }
                                </span>
                                {['yes', 'no'].map((opt) => (
                                  <div
                                    key={opt}
                                    onClick={() => {
                                      if (opt === 'yes') {
                                        setCollapseVisible('package');
                                        setIsPackage('yes');
                                      } else {
                                        ResetValue();
                                        setIsPackage('no');
                                        setCollapseVisible('accomodation');
                                      }
                                    }}
                                    className='gSemiBold'
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '4px',
                                      padding: '4px 8px',
                                      borderRadius: '4px',
                                      cursor: 'pointer',
                                      fontSize: '14px',
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: 20,
                                        height: 20,
                                        borderRadius: 4,
                                        background:
                                          isPackage === opt
                                            ? opt === 'yes'
                                              ? '#249968'
                                              : '#B22727'
                                            : '#EAEAEA',
                                      }}
                                      className='center justify-center'
                                    >
                                      <img
                                        alt='viewIcon'
                                        src={opt === 'yes' ? tick : cross}
                                      />
                                    </div>
                                    {activeLanguage?.reservation?.[opt]}
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                        <Collapse isOpened={collapseVisible === 'package'}>
                          <div className='pd-20'>
                            <div className='sb-blue-900 fs-18 gSemiBold mg-bottom-10'>
                              {
                                activeLanguage?.reservation
                                  ?.select_package_heading
                              }
                            </div>
                            <Row gutter={[10, 6]}>
                              {reservation
                                ?.filter((item) => item?.show_package_online)
                                ?.slice(packageStartIndex, packageEndIndex)
                                .map((record) => (
                                  <Col xs={24} sm={24} lg={12}>
                                    <div
                                      className={`select-package-container ${
                                        packageData?.id === record?.id
                                          ? 'selected'
                                          : ''
                                      }  w-full br10   row-center cp`}
                                      onClick={() => {
                                        setAccommodationBookingDates([
                                          { ...emptyDatesObject },
                                        ]);
                                        handleChange('fishing.dates', []);
                                        setPackageData(record);
                                      }}
                                    >
                                      {record?.package_image ? (
                                        <img
                                          width={105}
                                          height={65}
                                          className='br10 '
                                          style={{ objectFit: 'cover' }}
                                          src={record?.package_image}
                                        />
                                      ) : (
                                        <div
                                          className='product-add-on-no-image gSemiBold fs-12'
                                          style={{
                                            minWidth: '100px',
                                            height: '65px',
                                          }}
                                        >
                                          {
                                            activeLanguage?.reservation
                                              ?.no_image
                                          }
                                        </div>
                                      )}
                                      <div className='w-full'>
                                        <div className='sb-blue-900 fs-16 gSemiBold'>
                                          {record?.name}
                                        </div>
                                        <div className='sb-blue-900 fs-16 gSemiBold row-center justify-between flex-wrap'>
                                          <div>
                                            THB{' '}
                                            {record?.final_price_in_pence / 100}
                                          </div>
                                          <div className='gBold  fs-10 row-center fs-10'>
                                            {record?.package_type ===
                                              'last_minute' ||
                                            record?.package_type ===
                                              'early_bird' ? (
                                              <span
                                                className=' fs-10 txt-center '
                                                style={{
                                                  borderRadius: '100px',
                                                  background: '#FFD98F',
                                                  color: '#5C3D00',
                                                  width: 120,
                                                  padding: '2px 12px',
                                                }}
                                              >
                                                {
                                                  activeLanguage?.reservation?.[
                                                    record?.package_type
                                                  ]
                                                }
                                              </span>
                                            ) : record?.package_type ===
                                              'specific_date_range' ? (
                                              <span
                                                className=' fs-10 txt-center '
                                                style={{
                                                  borderRadius: '100px',
                                                  background: '#D9EEFF',
                                                  color: '#0D3759',
                                                  width: 120,
                                                  padding: '2px 12px',
                                                }}
                                              >
                                                {
                                                  activeLanguage?.reservation
                                                    ?.date_range
                                                }
                                              </span>
                                            ) : (
                                              ''
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Col>
                                ))}
                            </Row>
                            <Pagination
                              className='mg-top-30  justify-center'
                              current={packageCurrentPage}
                              onChange={(p) => setPackageCurrentPage(p)}
                              total={reservation?.length}
                              pageSize={6}
                              showSizeChanger={false}
                            />
                            <Row justify='center'>
                              <Button
                                type='primary'
                                disabled={!packageData}
                                onClick={() => {
                                  if (packageData?.has_accommodation) {
                                    setCollapseVisible('accomodation');
                                  } else if (packageData?.supports_fishing) {
                                    setCollapseVisible('fishing');
                                  }
                                }}
                                className={`continue-btn ${
                                  !packageData
                                    ? 'grey-bg-300'
                                    : 'sb-blue-bg-700'
                                } 
            sb-blue-bg-700 white fs-18 gSemiBold h-full w-fit`}
                              >
                                {activeLanguage?.reservation?.save_continue}
                              </Button>
                            </Row>
                          </div>
                        </Collapse>
                      </div>

                      <div className='individual-container mg-bottom-10'>
                        <div
                          className='pd-20 cp'
                          onClick={() => {
                            if (formData?.accomodation?.include === 'yes') {
                              setCollapseVisible('accomodation');
                            }
                          }}
                        >
                          <div className='fs-18 row-center gSemiBold justify-between mg-bottom-0'>
                            <div className='row-center w-full justify-between flex-wrap gap-05r'>
                              <div className='row-center'>
                                <div
                                  className='sb-blue-bg-600 br5 center justify-center mg-right-10'
                                  style={{ minWidth: 34, height: 34 }}
                                >
                                  <img src={bedIcon} alt='bed-icon' />
                                </div>
                                <div className='row-center justify-between'>
                                  <div className='fs-18'>
                                    {activeLanguage?.reservation?.accommodation}
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  alignItems: 'center',
                                  gap: '8px',
                                }}
                              >
                                {!packageData && (
                                  <>
                                    <span className='fs-14 gRegular'>
                                      {
                                        activeLanguage?.reservation
                                          ?.accommodationQuestion
                                      }
                                    </span>
                                    <div
                                      className='row-center'
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      {renderOptions('accomodation')}
                                    </div>
                                  </>
                                )}
                                {formData?.accomodation?.completed &&
                                  formData?.accomodation?.include === 'yes' && (
                                    <div
                                      className='cp txt-underline fs-13 gBold grey-800'
                                      onClick={() => {
                                        setCollapseVisible('accomodation');
                                      }}
                                    >
                                      {activeLanguage?.reservation?.edit}
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <Collapse isOpened={collapseVisible === 'accomodation'}>
                          <div className='pd-20'>
                            <Row
                              gutter={[16, 16]}
                              align='middle'
                              className='mg-bottom-20'
                            >
                              {!packageData && (
                                <div
                                  style={{
                                    display: 'flex',
                                    width: '100%',
                                    flexWrap: 'wrap',
                                    rowGap: 10,
                                    alignItems: 'center',
                                  }}
                                >
                                  <Col
                                    xs={24}
                                    sm={24}
                                    xl={11}
                                    className=' gap-1r flex-wrap'
                                  >
                                    <div className='gSemiBold sb-blue-900 fs-16 mg-bottom-10'>
                                      {
                                        activeLanguage?.reservation
                                          ?.numberOfGuests
                                      }
                                    </div>
                                    <div className='display-flex-row flex-wrap gap-1r'>
                                      {['adults', 'children', 'teen'].map(
                                        (type) => (
                                          <div
                                            className='display-flex-row'
                                            key={type}
                                          >
                                            <div className='sb-blue-900 fs-16 gRegular'>
                                              {
                                                activeLanguage?.reservation?.[
                                                  type
                                                ]
                                              }
                                            </div>
                                            <button
                                              className='icon-button'
                                              disabled={
                                                packageData ||
                                                formData.accomodation.guests[
                                                  type
                                                ] === 0
                                              }
                                              onClick={() =>
                                                handleGuestChange(type, -1)
                                              }
                                            >
                                              <MinusCircleOutlined
                                                style={{
                                                  color:
                                                    packageData ||
                                                    formData.accomodation
                                                      .guests[type] === 0
                                                      ? '#CCD3D9'
                                                      : '#5C6166',
                                                }}
                                              />
                                            </button>
                                            <div>
                                              {
                                                formData.accomodation.guests[
                                                  type
                                                ]
                                              }
                                            </div>
                                            <button
                                              className='icon-button'
                                              disabled={packageData}
                                              onClick={() =>
                                                handleGuestChange(type, 1)
                                              }
                                            >
                                              <PlusCircleOutlined
                                                style={{
                                                  color: packageData
                                                    ? '#CCD3D9'
                                                    : '#5C6166',
                                                }}
                                              />
                                            </button>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </Col>
                                  <Col xs={0} sm={0} xl={1}>
                                    <Divider
                                      type='vertical'
                                      style={{
                                        height: '3.5rem',
                                        border: '1px solid black',
                                      }}
                                    />
                                  </Col>
                                  <Col
                                    xs={24}
                                    sm={24}
                                    xl={12}
                                    className=' gap-1r flex-wrap'
                                  >
                                    <div className='gSemiBold sb-blue-900 fs-16 mg-bottom-10'>
                                      {
                                        activeLanguage?.reservation
                                          ?.numberOfRooms
                                      }
                                    </div>
                                    <div className='display-flex-row flex-wrap gap-1r'>
                                      {formData.accomodation.rooms.map(
                                        (room) => (
                                          <div
                                            className='display-flex-row'
                                            key={room.product_id}
                                          >
                                            <div className='sb-blue-900 fs-16 gRegular'>
                                              {room.name}
                                            </div>
                                            <button
                                              className='icon-button'
                                              disabled={
                                                packageData ||
                                                room.quantity <= 0
                                              }
                                              onClick={() =>
                                                handleRoomChange(
                                                  room.product_id,
                                                  -1
                                                )
                                              }
                                            >
                                              <MinusCircleOutlined
                                                style={{
                                                  color:
                                                    packageData ||
                                                    room.quantity <= 0
                                                      ? '#CCD3D9'
                                                      : '#5C6166',
                                                }}
                                              />
                                            </button>
                                            <div>{room.quantity}</div>
                                            <button
                                              className='icon-button'
                                              disabled={
                                                packageData ||
                                                room?.quantity >=
                                                  room.capacity ||
                                                totalRooms >= maxRooms
                                              }
                                              onClick={() =>
                                                handleRoomChange(
                                                  room.product_id,
                                                  1
                                                )
                                              }
                                            >
                                              <PlusCircleOutlined
                                                style={{
                                                  color:
                                                    packageData ||
                                                    room?.quantity >=
                                                      room.capacity ||
                                                    totalRooms >= maxRooms
                                                      ? '#CCD3D9'
                                                      : '#5C6166',
                                                }}
                                              />
                                            </button>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </Col>
                                </div>
                              )}
                              <div className='w-full'>
                                <div
                                  className={`fishing-package-overlay ${
                                    isOverlayActive ? 'active' : ''
                                  }`}
                                >
                                  {isOverlayActive && (
                                    <div className='overlay-message'>
                                      <div className='text fs-18 gSemiBold'>
                                        {
                                          activeLanguage?.reservation
                                            ?.accommodationAvailabilityReminder
                                        }
                                      </div>
                                    </div>
                                  )}
                                  <SelectDate
                                    handleChange={handleChange}
                                    activeLanguage={activeLanguage}
                                    lake_id={AccommodationLake?.lake_id}
                                    bookingDates={accommodationBookingDates}
                                    setBookingDates={
                                      setAccommodationBookingDates
                                    }
                                    data={formData.accomodation}
                                  />
                                </div>
                              </div>
                              <div className='sb-blue-900 gRegular txt-center w-full'>
                                <span className='gSemiBold'>
                                  {activeLanguage?.reservation?.checkIn}
                                </span>{' '}
                                {activeLanguage?.reservation?.checkInPrefix}{' '}
                                <span className='seagreen-600 gSemiBold'>
                                  2pm
                                </span>{' '}
                                {activeLanguage?.reservation?.checkInSuffix} |{' '}
                                <span className='gSemiBold'>
                                  {activeLanguage?.reservation?.checkOut}
                                </span>{' '}
                                {activeLanguage?.reservation?.checkOutPrefix}{' '}
                                <span className='seagreen-600 gSemiBold'>
                                  10am
                                </span>{' '}
                                {activeLanguage?.reservation?.checkOutSuffix}
                              </div>
                            </Row>
                            <Row justify='center'>
                              <Button
                                type='primary'
                                disabled={
                                  isOverlayActive ||
                                  !accommodationBookingDates[0].startDate ||
                                  !accommodationBookingDates[0].endDate ||
                                  !accommodationBookingDates[0].endDate ||
                                  dayjs(
                                    accommodationBookingDates[0].startDate
                                  ).isSame(
                                    dayjs(accommodationBookingDates[0].endDate),
                                    'day'
                                  )
                                }
                                onClick={() => {
                                  handleChange('accomodation', {
                                    include: 'yes',
                                    completed: true,
                                  });
                                  handleChange('fishing', {
                                    include:
                                      formData?.fishing?.include ?? 'yes',
                                  });
                                  const startDate =
                                    accommodationBookingDates?.[0]?.startDate;

                                  const endDate =
                                    accommodationBookingDates?.[0]?.endDate;
                                  const dates = formData?.fishing?.dates;
                                  const accommodation_days =
                                    startDate && endDate
                                      ? Math.max(
                                          1,
                                          dayjs(end).diff(dayjs(start), 'day')
                                        )
                                      : formData?.accomodation?.include === 'no'
                                        ? 1
                                        : 1;
                                  if (
                                    formData?.fishing?.angler >
                                      formData?.accomodation?.guests?.adults +
                                        formData?.accomodation?.guests
                                          ?.children +
                                        formData?.accomodation?.guests?.teen &&
                                    !packageData
                                  ) {
                                    handleChange('fishing', {
                                      angler:
                                        formData?.accomodation?.guests?.adults +
                                        formData?.accomodation?.guests
                                          ?.children +
                                        formData?.accomodation?.guests?.teen,
                                      swims:
                                        formData?.accomodation?.guests?.adults +
                                        formData?.accomodation?.guests
                                          ?.children +
                                        formData?.accomodation?.guests?.teen,
                                    });
                                  }
                                  if (
                                    formData?.fishing?.fishing_days >
                                    accommodation_days + 1
                                  ) {
                                    handleChange('fishing', {
                                      fishing_days: accommodation_days + 1,
                                    });
                                  }
                                  const filteredDates = dates.filter((date) => {
                                    return (
                                      dayjs(date).isSameOrAfter(
                                        dayjs(startDate),
                                        'day'
                                      ) &&
                                      dayjs(date).isSameOrBefore(
                                        dayjs(endDate),
                                        'day'
                                      )
                                    );
                                  });
                                  if (filteredDates?.length > 0) {
                                    handleChange(
                                      'fishing.dates',
                                      filteredDates
                                    );
                                  } else {
                                    handleChange('fishing.dates', [
                                      dayjs(startDate).format('YYYY-MM-DD'),
                                    ]);
                                    setCalendarKey((prev) => prev + 1);
                                  }
                                  if (formData?.fishing?.include !== 'no') {
                                    setCollapseVisible('fishing');
                                    handleChange('fishing.include', 'yes');
                                  } else if (
                                    formData?.fishing?.include === 'no' &&
                                    formData?.taxi?.include === 'yes'
                                  ) {
                                    setCollapseVisible('taxi');
                                  } else {
                                    setCollapseVisible('');
                                  }
                                }}
                                className={`continue-btn ${
                                  isOverlayActive ||
                                  !accommodationBookingDates[0].startDate ||
                                  !accommodationBookingDates[0].endDate ||
                                  !accommodationBookingDates[0].endDate ||
                                  dayjs(
                                    accommodationBookingDates[0].startDate
                                  ).isSame(
                                    dayjs(accommodationBookingDates[0].endDate),
                                    'day'
                                  )
                                    ? 'grey-bg-300'
                                    : 'sb-blue-bg-700'
                                } sb-blue-bg-700 white fs-18 gSemiBold h-full w-fit`}
                              >
                                {activeLanguage?.reservation?.saveAndContinue}
                              </Button>
                            </Row>
                          </div>
                        </Collapse>
                      </div>

                      <div
                        className={`individual-container ${
                          !formData?.accomodation?.completed
                            ? 'grey-bg-100'
                            : ''
                        } mg-bottom-10`}
                      >
                        <div
                          className={`pd-20 ${
                            formData?.accomodation?.completed ? 'cp' : ''
                          }`}
                          onClick={() => {
                            if (
                              formData?.fishing?.include === 'yes' &&
                              formData?.accomodation?.completed
                            ) {
                              setCollapseVisible('fishing');
                            }
                          }}
                        >
                          <div className='fs-18 row-center gSemiBold justify-between mg-bottom-0'>
                            <div className='row-center w-full justify-between flex-wrap gap-05r'>
                              <div className='row-center'>
                                <div
                                  className='sb-blue-bg-600 br5 center justify-center mg-right-10'
                                  style={{ minWidth: 34, height: 34 }}
                                >
                                  <img src={fishIcon} alt='bed-icon' />
                                </div>
                                <div className='row-center  justify-between'>
                                  <div className='fs-18 '>
                                    {activeLanguage?.reservation?.fishing}
                                  </div>
                                </div>
                              </div>
                              {formData?.accomodation?.completed ? (
                                <div
                                  style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                    gap: '8px',
                                  }}
                                >
                                  {!packageData && (
                                    <>
                                      <span className='fs-14 gRegular'>
                                        {
                                          activeLanguage?.reservation
                                            ?.fishingQuestion
                                        }
                                      </span>
                                      <div
                                        className='row-center'
                                        onClick={(e) => e.stopPropagation()}
                                      >
                                        {renderOptions('fishing')}
                                      </div>
                                    </>
                                  )}
                                  {formData?.fishing?.completed &&
                                    formData?.fishing?.include === 'yes' && (
                                      <div
                                        className='cp txt-underline fs-13 gBold grey-800'
                                        onClick={() => {
                                          setCollapseVisible('fishing');
                                        }}
                                      >
                                        {activeLanguage?.reservation?.edit}
                                      </div>
                                    )}
                                </div>
                              ) : (
                                <div className='sb-blue-900 gSemiBold fs-18'>
                                  {activeLanguage?.reservation?.step} 2
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <Collapse isOpened={collapseVisible === 'fishing'}>
                          <div className='pd-20'>
                            <FishingSection
                              lakes={lakes}
                              activeLanguage={activeLanguage}
                              data={formData}
                              accommodationDates={accommodationBookingDates}
                              setCollapseVisible={setCollapseVisible}
                              handleChange={handleChange}
                            />
                          </div>
                        </Collapse>
                      </div>
                      <div
                        className={`individual-container ${
                          !formData?.fishing?.completed &&
                          countCompletedSections < 2
                            ? 'grey-bg-100'
                            : ''
                        } mg-bottom-10`}
                      >
                        <div
                          className={`pd-20 ${
                            formData?.fishing?.completed &&
                            countCompletedSections >= 2
                              ? 'cp'
                              : ''
                          }`}
                          onClick={() => {
                            if (
                              formData?.taxi?.include === 'yes' &&
                              formData?.fishing?.completed
                            ) {
                              setCollapseVisible('taxi');
                            }
                          }}
                        >
                          <div className='fs-18 row-center gSemiBold justify-between mg-bottom-0'>
                            <div className='row-center w-full justify-between flex-wrap gap-05r'>
                              <div className='row-center'>
                                <div
                                  className='sb-blue-bg-600 br5 center justify-center mg-right-10'
                                  style={{ minWidth: 34, height: 34 }}
                                >
                                  <img src={taxiIcon} alt='bed-icon' />
                                </div>
                                <div className='row-center  justify-between'>
                                  <div className='fs-18 '>
                                    {activeLanguage?.reservation?.Taxi}
                                  </div>
                                </div>
                              </div>
                              {formData?.fishing?.completed ? (
                                <div
                                  style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                    gap: '8px',
                                  }}
                                >
                                  <span className='fs-14 gRegular'>
                                    {activeLanguage?.reservation?.taxiQuestion}
                                  </span>
                                  <div
                                    className='row-center'
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    {renderOptions('taxi')}
                                  </div>
                                  {formData?.taxi?.completed &&
                                    formData?.taxi?.include === 'yes' && (
                                      <div
                                        className='cp txt-underline fs-13 gBold grey-800'
                                        onClick={() => {
                                          setCollapseVisible('taxi');
                                        }}
                                      >
                                        {activeLanguage?.reservation?.edit}
                                      </div>
                                    )}
                                </div>
                              ) : (
                                <div className='sb-blue-900 gSemiBold fs-18'>
                                  {activeLanguage?.reservation?.step} 3
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <Collapse isOpened={collapseVisible === 'taxi'}>
                          <div className='pd-20'>
                            <Row gutter={[20, 16]} className='mg-bottom-20'>
                              <Col xs={24} sm={24} lg={12}>
                                <div className='display-flex-row mg-bottom-10'>
                                  <div
                                    className='gSemiBold sb-blue-900 row-center'
                                    style={{ minWidth: 139 }}
                                  >
                                    {
                                      activeLanguage?.reservation?.taxi
                                        ?.addPickupTaxi
                                    }
                                  </div>
                                  <Select
                                    value={isTaxi}
                                    onChange={(v) => {
                                      setIsTaxi(v);
                                      if (
                                        accommodationBookingDates?.[0]
                                          ?.startDate &&
                                        v === 'yes'
                                      ) {
                                        const dateWith7AM = dayjs(
                                          accommodationBookingDates[0].startDate
                                        )
                                          .hour(7)
                                          .minute(0)
                                          .second(0);
                                        handleChange(
                                          'taxi.pickupDateTime',
                                          dateWith7AM.format('YYYY-MM-DD HH:mm')
                                        );
                                      } else {
                                        handleChange('taxi.pickupDateTime', '');
                                      }
                                    }}
                                    className='w-full gMedium fs-16 h-full'
                                    popupClassName='admin-manage-booking-steps-select-list gRegular'
                                  >
                                    <Option value='yes'>
                                      {activeLanguage?.reservation?.taxi?.yes}
                                    </Option>
                                    <Option value='no'>
                                      {activeLanguage?.reservation?.taxi?.no}
                                    </Option>
                                  </Select>
                                </div>
                                <div className='display-flex-row mg-bottom-10'>
                                  <div
                                    className='gSemiBold sb-blue-900 row-center'
                                    style={{ minWidth: 139 }}
                                  >
                                    {
                                      activeLanguage?.reservation?.taxi
                                        ?.pickupDateTime
                                    }
                                  </div>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DateTimePicker
                                      label={
                                        activeLanguage?.reservation?.taxi
                                          ?.selectTime
                                      }
                                      value={
                                        (formData.taxi.pickupDateTime &&
                                          dayjs(
                                            formData.taxi.pickupDateTime
                                          )) ||
                                        null
                                      }
                                      onChange={(value) => {
                                        handleChange(
                                          'taxi.pickupDateTime',
                                          dayjs(value).format(
                                            'YYYY-MM-DD HH:mm'
                                          )
                                        );
                                      }}
                                      disabled={isTaxi === 'no'}
                                      className='br5 bg-white gRegular w-full'
                                      id='gRegular'
                                      format='DD/MM/YYYY HH:mm'
                                      slotProps={{
                                        textField: {
                                          size: 'small',
                                          InputLabelProps: { shrink: false },
                                          sx: {
                                            '.MuiInputLabel-root': {
                                              display: 'none',
                                            },
                                            maxWidth: '100%',
                                            float: 'right',
                                            height: '32px',
                                            '.MuiInputBase-root': {
                                              fontFamily: 'gRegular',
                                              backgroundColor:
                                                isTaxi === 'yes'
                                                  ? 'white'
                                                  : '#f5f5f5',
                                              marginTop: 0,
                                              height: '32px',
                                            },
                                          },
                                        },
                                      }}
                                    />
                                  </LocalizationProvider>
                                </div>
                                <div className='display-flex-row'>
                                  <div
                                    className='gSemiBold sb-blue-900'
                                    style={{ minWidth: 139 }}
                                  >
                                    {
                                      activeLanguage?.reservation?.taxi
                                        ?.pickupLocation
                                    }
                                  </div>
                                  <Input.TextArea
                                    value={formData.taxi.pickupLocation || null}
                                    onChange={(e) => {
                                      handleChange(
                                        'taxi.pickupLocation',
                                        e.target.value
                                      );
                                    }}
                                    className='gRegular'
                                    disabled={isTaxi === 'no'}
                                  />
                                </div>
                              </Col>
                              <Col xs={24} sm={24} lg={12}>
                                <div className='display-flex-row mg-bottom-10'>
                                  <div
                                    className='gSemiBold sb-blue-900 row-center'
                                    style={{ minWidth: 139 }}
                                  >
                                    {
                                      activeLanguage?.reservation?.taxi
                                        ?.addDropoffTaxi
                                    }
                                  </div>
                                  <Select
                                    value={isDropoffTaxi}
                                    onChange={(v) => {
                                      setIsDropoffTaxi(v);
                                      if (
                                        accommodationBookingDates?.[0]
                                          ?.endDate &&
                                        v === 'yes'
                                      ) {
                                        const dateWith7PM = dayjs(
                                          accommodationBookingDates[0].endDate
                                        )
                                          .hour(19)
                                          .minute(0)
                                          .second(0);
                                        handleChange(
                                          'taxi.dropoffDateTime',
                                          dateWith7PM.format('YYYY-MM-DD HH:mm')
                                        );
                                      } else {
                                        handleChange(
                                          'taxi.dropoffDateTime',
                                          ''
                                        );
                                      }
                                    }}
                                    className='w-full gMedium fs-16 h-full'
                                    popupClassName='admin-manage-booking-steps-select-list gRegular'
                                  >
                                    <Option value='yes'>
                                      {activeLanguage?.reservation?.taxi?.yes}
                                    </Option>
                                    <Option value='no'>
                                      {activeLanguage?.reservation?.taxi?.no}
                                    </Option>
                                  </Select>
                                </div>
                                <div className='display-flex-row mg-bottom-10'>
                                  <div
                                    className='gSemiBold sb-blue-900 row-center'
                                    style={{ minWidth: 139 }}
                                  >
                                    {
                                      activeLanguage?.reservation?.taxi
                                        ?.dropoffDateTime
                                    }
                                  </div>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DateTimePicker
                                      label={
                                        activeLanguage?.reservation?.taxi
                                          ?.selectTime
                                      }
                                      value={
                                        (formData.taxi.dropoffDateTime &&
                                          dayjs(
                                            formData.taxi.dropoffDateTime
                                          )) ||
                                        null
                                      }
                                      onChange={(value) => {
                                        handleChange(
                                          'taxi.dropoffDateTime',
                                          dayjs(value).format(
                                            'YYYY-MM-DD HH:mm'
                                          )
                                        );
                                      }}
                                      disabled={isDropoffTaxi === 'no'}
                                      className='br5 bg-white gRegular w-full'
                                      id='gRegular'
                                      format='DD/MM/YYYY HH:mm'
                                      slotProps={{
                                        textField: {
                                          size: 'small',
                                          InputLabelProps: { shrink: false },
                                          sx: {
                                            '.MuiInputLabel-root': {
                                              display: 'none',
                                            },
                                            maxWidth: '100%',
                                            float: 'right',
                                            height: '32px',
                                            '.MuiInputBase-root': {
                                              fontFamily: 'gRegular',
                                              backgroundColor:
                                                isDropoffTaxi === 'yes'
                                                  ? 'white'
                                                  : '#f5f5f5',
                                              marginTop: 0,
                                              height: '32px',
                                            },
                                          },
                                        },
                                      }}
                                    />
                                  </LocalizationProvider>
                                </div>
                                <div className='display-flex-row'>
                                  <div
                                    className='gSemiBold sb-blue-900'
                                    style={{ minWidth: 139 }}
                                  >
                                    {
                                      activeLanguage?.reservation?.taxi
                                        ?.dropoffLocation
                                    }
                                  </div>
                                  <Input.TextArea
                                    value={
                                      formData.taxi.dropoffLocation || null
                                    }
                                    onChange={(e) => {
                                      handleChange(
                                        'taxi.dropoffLocation',
                                        e.target.value
                                      );
                                    }}
                                    className='gRegular'
                                    disabled={isDropoffTaxi === 'no'}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <div className='mg-top-30 row-center justify-center w-full mg-bottom-30'>
                              <div className='center mg-right-20'>
                                <div className='sb-blue-900 gSemiBold'>
                                  {
                                    activeLanguage?.reservation?.taxi
                                      ?.infoNotAvailableTitle
                                  }
                                </div>
                                <div className='fs-12 gRegular'>
                                  {
                                    activeLanguage?.reservation?.taxi
                                      ?.infoNotAvailableNote
                                  }
                                </div>
                              </div>
                              <div>
                                <Checkbox
                                  checked={formData?.taxi.infoNotAvailable}
                                  onChange={(e) => {
                                    handleChange('taxi', {
                                      infoNotAvailable: e.target.checked,
                                      pickupDateTime: '',
                                      pickupLocation: '',
                                      dropoffDateTime: '',
                                      dropoffLocation: '',
                                    });
                                  }}
                                />
                              </div>
                            </div>
                            <Row justify='center'>
                              <Button
                                type='primary'
                                onClick={() => {
                                  handleChange('taxi.completed', true);
                                  if (formData?.add_ons?.include !== 'no') {
                                    setCollapseVisible('add_ons');
                                    handleChange('add_ons.include', 'yes');
                                  } else {
                                    handleChange('add_ons.completed', true);
                                    setCollapseVisible('guest_details');
                                  }
                                }}
                                disabled={taxiDisabled}
                                className={`continue-btn ${
                                  taxiDisabled
                                    ? 'grey-bg-300'
                                    : 'sb-blue-bg-700'
                                } white fs-18 gSemiBold h-full w-fit`}
                              >
                                {
                                  activeLanguage?.reservation?.taxi
                                    ?.saveAndContinue
                                }
                              </Button>
                            </Row>
                          </div>
                        </Collapse>
                      </div>
                      <div
                        className={`individual-container ${
                          !formData?.taxi?.completed ? 'grey-bg-100' : ''
                        } mg-bottom-10`}
                      >
                        <div
                          className={`pd-20 ${
                            formData?.taxi?.completed ? 'cp' : ''
                          }`}
                          onClick={() => {
                            if (
                              formData?.add_ons?.include === 'yes' &&
                              formData?.taxi?.completed
                            ) {
                              setCollapseVisible('add_ons');
                            }
                          }}
                        >
                          <div className='fs-18 row-center gSemiBold justify-between mg-bottom-0'>
                            <div className='row-center w-full justify-between flex-wrap gap-05r'>
                              <div className='row-center'>
                                <div
                                  className='sb-blue-bg-600 br5 center justify-center mg-right-10'
                                  style={{ minWidth: 34, height: 34 }}
                                >
                                  <img src={boxIcon} alt='bed-icon' />
                                </div>
                                <div className='row-center  justify-between'>
                                  <div className='fs-18 '>
                                    {activeLanguage?.reservation?.add_ons}
                                  </div>
                                </div>
                              </div>
                              {formData?.taxi?.completed ? (
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    gap: '8px',
                                  }}
                                >
                                  <span className='fs-14 gRegular'>
                                    {
                                      activeLanguage?.reservation
                                        ?.addOnsQuestion
                                    }
                                  </span>
                                  <div
                                    className='row-center'
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    {renderOptions('add_ons')}
                                  </div>
                                  {formData?.add_ons?.completed &&
                                    formData?.add_ons?.include === 'yes' && (
                                      <div
                                        className='cp txt-underline fs-13 gBold grey-800'
                                        onClick={() => {
                                          setCollapseVisible('add_ons');
                                        }}
                                      >
                                        {activeLanguage?.reservation?.edit}
                                      </div>
                                    )}
                                </div>
                              ) : (
                                <div className='sb-blue-900 gSemiBold fs-18'>
                                  {activeLanguage?.reservation?.step} 4
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <Collapse isOpened={collapseVisible === 'add_ons'}>
                          <div className='pd-20 pd-top-0'>
                            <Row gutter={[10, 15]}>
                              {cartItems
                                ?.slice(startIndex, endIndex)
                                ?.map((item) => (
                                  <ProductItem
                                    key={item?.id}
                                    item={item}
                                    disabled={packageData}
                                    onIncrease={() =>
                                      handleIncrease(
                                        item.id,
                                        item.quantity,
                                        item.max_quantity
                                      )
                                    }
                                    onDecrease={() =>
                                      handleDecrease(item.id, item.quantity)
                                    }
                                  />
                                ))}
                            </Row>
                            {cartItems?.length > 0 && (
                              <Pagination
                                className='mg-top-30  justify-center'
                                current={currentPage}
                                onChange={onChangePagination}
                                total={cartItems?.length}
                                pageSize={8}
                                showSizeChanger={false}
                              />
                            )}
                            <Row justify='center'>
                              <Button
                                type='primary'
                                onClick={() => {
                                  handleChange('add_ons.completed', true);
                                  if (addedItems?.length) {
                                    handleChange('add_ons.include', 'yes');
                                  }
                                  setCollapseVisible('guest_details');
                                }}
                                disabled={!hasAddonQuantity}
                                className={`continue-btn ${
                                  !hasAddonQuantity
                                    ? 'grey-bg-300'
                                    : 'sb-blue-bg-700'
                                } white mg-top-20 fs-18 gSemiBold h-full w-fit`}
                              >
                                {activeLanguage?.reservation?.saveAndContinue}
                              </Button>
                            </Row>
                          </div>
                        </Collapse>
                      </div>
                      <div
                        className={`individual-container ${
                          !formData?.add_ons?.completed ? 'grey-bg-100' : ''
                        } mg-bottom-10`}
                      >
                        <div
                          className={`pd-20 ${
                            formData?.add_ons?.completed ? 'cp' : ''
                          }`}
                          onClick={() => {
                            if (formData?.add_ons?.completed) {
                              setCollapseVisible('guest_details');
                            }
                          }}
                        >
                          <div className='fs-18 row-center gSemiBold justify-between mg-bottom-0'>
                            <div className='row-center w-full justify-between flex-wrap gap-05r'>
                              <div className='row-center'>
                                <div
                                  className='sb-blue-bg-600 br5 center justify-center mg-right-10'
                                  style={{ minWidth: 34, height: 34 }}
                                >
                                  <img src={userIcon} alt='user-icon' />
                                </div>
                                <div className='row-center  justify-between'>
                                  <div className='fs-18 '>
                                    {activeLanguage?.reservation?.guest_details}
                                  </div>
                                </div>
                              </div>
                              {formData?.add_ons?.completed ? (
                                <div
                                  style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                    gap: '8px',
                                  }}
                                >
                                  {formData?.guest_details?.completed && (
                                    <div className='row-center'>
                                      <div className='gBOld seagreen-600 uppercase fs-14 mg-right-16'>
                                        {activeLanguage?.reservation?.completed}
                                      </div>

                                      <div
                                        className='cp txt-underline fs-13 gBold grey-800'
                                        onClick={() => {
                                          setCollapseVisible('guest_details');
                                        }}
                                      >
                                        {activeLanguage?.reservation?.edit}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <div className='sb-blue-900 gSemiBold fs-18'>
                                  {activeLanguage?.reservation?.step} 5
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <Collapse
                          isOpened={collapseVisible === 'guest_details'}
                        >
                          <div className='pd-20 pd-top-0'>
                            <div className='mg-bottom-20 gMedium'>
                              <div className='fs-16 sb-blue-900 gSemiBold mg-bottom-20'>
                                {activeLanguage?.reservation?.leadGuest?.title}
                              </div>
                              <Row gutter={[20, 12]} className='mg-bottom-10'>
                                <Col xs={24} sm={24} lg={12}>
                                  <Row className='row-center'>
                                    <Col
                                      span={8}
                                      className='sb-blue-900 gSemiBold'
                                    >
                                      {
                                        activeLanguage?.reservation?.leadGuest
                                          ?.guestTitle
                                      }
                                    </Col>
                                    <Col span={16}>
                                      <Select
                                        placeholder={
                                          activeLanguage?.reservation?.leadGuest
                                            ?.selectTitle
                                        }
                                        className='w-full gMedium'
                                        value={formData?.guest_details?.title}
                                        onChange={(v) => {
                                          handleChange(
                                            'guest_details.title',
                                            v
                                          );
                                        }}
                                        style={{ maxWidth: 150 }}
                                      >
                                        <Option className='gMedium' value='Mr'>
                                          {
                                            activeLanguage?.reservation
                                              ?.leadGuest?.mr
                                          }
                                        </Option>
                                        <Option className='gMedium' value='Mrs'>
                                          {
                                            activeLanguage?.reservation
                                              ?.leadGuest?.mrs
                                          }
                                        </Option>
                                        <Option
                                          className='gMedium'
                                          value='Miss'
                                        >
                                          {
                                            activeLanguage?.reservation
                                              ?.leadGuest?.miss
                                          }
                                        </Option>
                                        <Option className='gMedium' value='Ms'>
                                          {
                                            activeLanguage?.reservation
                                              ?.leadGuest?.ms
                                          }
                                        </Option>
                                        <Option className='gMedium' value='Dr'>
                                          {
                                            activeLanguage?.reservation
                                              ?.leadGuest?.dr
                                          }
                                        </Option>
                                      </Select>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col xs={24} sm={24} lg={12}>
                                  <Row className='row-center'>
                                    <Col
                                      span={8}
                                      className='sb-blue-900 gSemiBold'
                                    >
                                      {
                                        activeLanguage?.reservation?.leadGuest
                                          ?.nationality
                                      }
                                    </Col>
                                    <Col span={16}>
                                      <Input
                                        style={{ maxWidth: 150 }}
                                        value={
                                          formData?.guest_details?.nationlity
                                        }
                                        onChange={(e) => {
                                          handleChange(
                                            'guest_details.nationality',
                                            e.target.value
                                          );
                                        }}
                                        className='br5'
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>

                              <Row gutter={[20, 12]} className='mg-bottom-10'>
                                <Col xs={24} sm={24} lg={12}>
                                  <Row className='row-center'>
                                    <Col
                                      span={8}
                                      className='sb-blue-900 gSemiBold'
                                    >
                                      {
                                        activeLanguage?.reservation?.leadGuest
                                          ?.firstName
                                      }
                                    </Col>
                                    <Col span={16}>
                                      <Input
                                        className='br5'
                                        value={
                                          formData?.guest_details?.first_name
                                        }
                                        onChange={(e) => {
                                          handleChange(
                                            'guest_details.first_name',
                                            e.target.value
                                          );
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                                <Col xs={24} sm={24} lg={12}>
                                  <Row className='row-center'>
                                    <Col
                                      span={8}
                                      className='sb-blue-900 gSemiBold'
                                    >
                                      {
                                        activeLanguage?.reservation?.leadGuest
                                          ?.lastName
                                      }
                                    </Col>
                                    <Col span={16}>
                                      <Input
                                        className='br5'
                                        value={
                                          formData?.guest_details?.last_name
                                        }
                                        onChange={(e) => {
                                          handleChange(
                                            'guest_details.last_name',
                                            e.target.value
                                          );
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>

                              <Row gutter={[20, 12]} className='mg-bottom-10'>
                                <Col xs={24} sm={24} lg={12}>
                                  <Row className='row-center'>
                                    <Col
                                      span={8}
                                      className='sb-blue-900 gSemiBold'
                                    >
                                      {
                                        activeLanguage?.reservation?.leadGuest
                                          ?.email
                                      }
                                    </Col>
                                    <Col span={16}>
                                      <Input
                                        className='br5'
                                        value={formData?.guest_details?.email}
                                        onChange={(e) => {
                                          handleChange(
                                            'guest_details.email',
                                            e.target.value
                                          );
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                                <Col xs={24} sm={24} lg={12}>
                                  <Row className='row-center'>
                                    <Col
                                      span={8}
                                      className='sb-blue-900 gSemiBold'
                                    >
                                      {
                                        activeLanguage?.reservation?.leadGuest
                                          ?.phoneNumber
                                      }
                                    </Col>
                                    <Col span={16}>
                                      <Input
                                        className='br5'
                                        type='number'
                                        value={
                                          formData?.guest_details?.phone_number
                                        }
                                        onChange={(e) => {
                                          handleChange(
                                            'guest_details.phone_number',
                                            e.target.value
                                          );
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </div>

                            <div className='mg-bottom-20'>
                              {customPropertyDetails?.length > 0 && (
                                <div className='fs-16 sb-blue-900 gSemiBold mg-bottom-20'>
                                  {
                                    activeLanguage?.reservation?.leadGuest
                                      ?.additionalInformation
                                  }
                                </div>
                              )}
                              <Row
                                gutter={[20, 12]}
                                className='mg-bottom-10 gMedium'
                              >
                                {customPropertyDetails?.map((item, i) => (
                                  <Col xs={24} sm={24} lg={12}>
                                    <Row className='row-center'>
                                      <Col
                                        span={8}
                                        className='sb-blue-900 gSemiBold'
                                      >
                                        {item?.field_name}
                                      </Col>
                                      <Col span={16}>
                                        {item?.field_type === 'text' ||
                                        item?.field_type === 'number' ? (
                                          <Input
                                            type={item?.field_type}
                                            value={item?.field_value}
                                            onChange={(e) => {
                                              const updatedDetails = [
                                                ...customPropertyDetails,
                                              ];
                                              updatedDetails[i] = {
                                                ...updatedDetails[i],
                                                field_value: e.target.value,
                                              };

                                              setCustomPropertyDetails(
                                                updatedDetails
                                              );
                                            }}
                                          />
                                        ) : item?.field_type === 'Dropdown' ? (
                                          <Select
                                            value={item?.field_value}
                                            onChange={(v) => {
                                              const updatedDetails = [
                                                ...customPropertyDetails,
                                              ];
                                              updatedDetails[i] = {
                                                ...updatedDetails[i],
                                                field_value: v,
                                              };
                                              setCustomPropertyDetails(
                                                updatedDetails
                                              );
                                            }}
                                            className='w-full gLight fs-16'
                                            popupClassName={
                                              'admin-manage-booking-steps-select-list'
                                            }
                                          >
                                            {item?.field_options?.map((id) => {
                                              return (
                                                <Option value={id}>{id}</Option>
                                              );
                                            })}
                                          </Select>
                                        ) : item?.field_type === 'note' ? (
                                          <Input.TextArea
                                            value={item?.field_value}
                                            onChange={(e) => {
                                              const updatedDetails = [
                                                ...customPropertyDetails,
                                              ];
                                              updatedDetails[i] = {
                                                ...updatedDetails[i],
                                                field_value: e.target.value,
                                              };
                                              setCustomPropertyDetails(
                                                updatedDetails
                                              );
                                            }}
                                          />
                                        ) : item?.field_type === 'date' ? (
                                          <LocalizationProvider
                                            dateAdapter={AdapterDayjs}
                                          >
                                            <DatePicker
                                              label='Select Date'
                                              style={{ fontFamily: 'gRegular' }}
                                              value={
                                                (item?.field_value &&
                                                  dayjs(item?.field_value)) ||
                                                null
                                              }
                                              onChange={(value) => {
                                                const updatedDetails = [
                                                  ...customPropertyDetails,
                                                ];
                                                updatedDetails[i] = {
                                                  ...updatedDetails[i],
                                                  field_value:
                                                    dayjs(value).format(
                                                      'YYYY-MM-DD'
                                                    ),
                                                };
                                                setCustomPropertyDetails(
                                                  updatedDetails
                                                );
                                              }}
                                              slotProps={{
                                                textField: {
                                                  size: 'small',
                                                  InputLabelProps: {
                                                    shrink: false,
                                                  }, // Prevent the label from taking up space
                                                  sx: {
                                                    '.MuiInputLabel-root': {
                                                      display: 'none', // Hide label
                                                    },

                                                    float: 'right',
                                                    height: '32px', // Set desired height
                                                    '.MuiInputBase-root': {
                                                      marginTop: 0, // Remove top margin
                                                      height: '32px', // Adjust height of the input
                                                    },
                                                    // '.MuiOutlinedInput-notchedOutline': {
                                                    //   display: 'none',
                                                    // },
                                                  },
                                                },
                                              }}
                                              className='br5 bg-white gRegular w-full  '
                                              id='gRegular'
                                              format='DD/MM/YYYY'
                                            ></DatePicker>
                                          </LocalizationProvider>
                                        ) : (
                                          ''
                                        )}
                                      </Col>
                                    </Row>
                                  </Col>
                                ))}
                              </Row>
                            </div>
                            <div className='row-center gap-1r justify-between'>
                              <Button
                                type='primary'
                                disabled={guestDisabled}
                                className={`continue-btn ${
                                  guestDisabled
                                    ? 'grey-bg-300'
                                    : 'sb-blue-bg-700'
                                } white fs-16 gSemiBold h-full w-fit `}
                                onClick={() => {
                                  handleChange('guest_details.completed', true);
                                  setCollapseVisible('');
                                  updateCost();
                                }}
                                style={{ padding: '5px 30px', marginTop: 0 }}
                              >
                                {activeLanguage?.reservation?.leadGuest?.save}
                              </Button>
                            </div>
                          </div>
                        </Collapse>
                      </div>
                      {allCompleted && (
                        <div className='mg-bottom-20'>
                          <div className='mg-bottom-10 fs-22 gSemiBold pd-left-10 mg-top-40 '>
                            {
                              activeLanguage?.reservation
                                ?.finalPriceConfirmation
                            }
                          </div>
                          <div className='price-container'>
                            <div className='row-center mg-bottom-10 sb-blue-900 '>
                              <div
                                className='fs-20 gSemiBold '
                                style={{ marginRight: 35, minWidth: 120 }}
                              >
                                {activeLanguage?.quote_summary?.total_price}:
                              </div>
                              <div className='row-center'>
                                <div className='gSemiBold fs-14 mg-right-5'>
                                  ({currency} {currencySymbol})
                                </div>
                                <div
                                  className='seagreen-bg-700 br5 white fs-18 gSemiBold pd-left-5 pd-right-5 txt-right'
                                  style={{ minWidth: 100 }}
                                >
                                  {convertedCost?.totalPrice ??
                                    cost?.pricing_details?.pricing_breakdown
                                      ?.total_price ??
                                    0}
                                </div>
                              </div>
                            </div>

                            <div className='row-center mg-bottom-10 sb-blue-900'>
                              <div
                                className='fs-20 gSemiBold '
                                style={{ marginRight: 35, minWidth: 120 }}
                              >
                                {activeLanguage?.quote_summary?.pay_today}:
                                <div className='fs-12 gSemiBold txt-center'>
                                  ({activeLanguage?.quote_summary?.deposit_perc}
                                  )
                                </div>
                              </div>
                              <div className='row-center flex-wrap gap-05r'>
                                <div className='row-center'>
                                  <div className='gSemiBold fs-14 mg-right-5'>
                                    ({currency} {currencySymbol})
                                  </div>
                                  <div
                                    className='seagreen-bg-500 br5 white txt-right fs-18 gSemiBold pd-left-5 pd-right-5'
                                    style={{ minWidth: 100 }}
                                  >
                                    {convertedCost?.deposit ??
                                      cost?.pricing_details?.pricing_breakdown
                                        ?.advance_price ??
                                      0}
                                  </div>
                                </div>
                                <div className='fs-13 gMedium sb-blue-900 mg-left-20'>
                                  {activeLanguage?.reservation?.balancePaid}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='mg-top-30'>
                            <Checkbox
                              checked={formData?.guest_details.terms}
                              onChange={(e) => {
                                handleChange('guest_details', {
                                  terms: e.target.checked,
                                });
                              }}
                              className='gMedium fs-14 sb-blue-900'
                            >
                              {
                                activeLanguage?.reservation?.leadGuest
                                  ?.declaration
                              }
                            </Checkbox>
                          </div>
                          <div>
                            <Checkbox
                              checked={formData?.guest_details.price_terms}
                              onChange={(e) => {
                                handleChange('guest_details', {
                                  price_terms: e.target.checked,
                                });
                              }}
                              className='gMedium fs-14 sb-blue-900'
                            >
                              {activeLanguage?.reservation?.underStandPrice}{' '}
                              <span className='gBold'>
                                converted from THB to GBP at checkout
                              </span>{' '}
                              {activeLanguage?.reservation?.priceQuotedHere}
                            </Checkbox>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className='action-buttons'>
                      <div
                        type='text'
                        className='cancel fs-20 cp  gSemiBold txt-underline'
                        onClick={() => {
                          history.goBack();
                          resetData();
                        }}
                      >
                        {activeLanguage?.reservation?.cancel}
                      </div>
                      <Row justify='center'>
                        <Button
                          type='primary'
                          disabled={
                            !cost?.pricing_details ||
                            !allCompleted ||
                            !formData?.guest_details.terms ||
                            !formData?.guest_details.price_terms ||
                            (formData?.accomodation?.include === 'no' &&
                              formData?.fishing?.include === 'no')
                          }
                          loading={postLoading}
                          onClick={postBookingRequest}
                          className={`continue-btn ${
                            allCompleted &&
                            cost?.pricing_details &&
                            formData?.guest_details.terms &&
                            formData?.guest_details.price_terms &&
                            (formData?.accomodation?.include === 'yes' ||
                              formData?.fishing?.include === 'yes')
                              ? 'sb-blue-bg-700'
                              : 'grey-bg-300'
                          } white custom-width mg-top-0 fs-18 gSemiBold h-full w-fit`}
                        >
                          {activeLanguage?.reservation?.proceedToPayment}
                        </Button>
                      </Row>
                    </div>
                  </div>
                </Col>

                {/* Right Panel */}
                <Col xs={24} sm={24} md={24} lg={7} className='right-panel'>
                  {SummaryContent}
                </Col>
              </Row>
            </div>
          </div>
          <Drawer
            placement={'bottom'}
            open={showSummary}
            closeable={false}
            maskCloseable={true}
            title={null}
            header={null}
            footer={''}
            className={
              'search-drawer summary-filter-drawer summary-filter-drawer--mobile'
            }
            height={'100%'}
            width={'100%'}
            zIndex={1005}
            onClose={() => setShowSummary(false)}
          >
            {SummaryContent}
          </Drawer>

          <div
            className={`search-drawer summary-list-drawer ${
              showSummary ? 'summary-list-drawer--open' : ''
            }`}
            onClick={(e) => {
              e.preventDefault();
              setShowSummary(true);
            }}
          >
            <div
              className='white open-drawer-text sb-blue-bg-700 gSemiBold fs-18 txt-center w-full'
              onClick={() => setShowSummary(true)}
            >
              <div className='row-center fs-16 gSemiBold txt-underline'>
                <img src={summaryIcon} className='mg-right-10' alt='calendar' />

                {activeLanguage?.quote_summary?.viewSummary}
              </div>
              <div className='row-center'>
                <div className='mg-right-10'>
                  ({currency} {currencySymbol})
                </div>
                <div
                  className='bg-white br10 pd-5 txt-center fs-18 gSemiBold sb-blue-600'
                  style={{ minWidth: 120 }}
                >
                  {convertedCost?.totalPrice ??
                    cost?.pricing_details?.pricing_breakdown?.total_price ??
                    0}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {current === 'payment' && (
        <div style={{ maxWidth: 800, margin: 'auto' }}>
          <PaymentPage
            idField={{
              name: 'booking_public_id',
              value: bookingData?.public_id,
            }}
            amount={bookingData?.booking_price?.advance_price}
            // amount={'1568'}
            enableStoredCards={true}
            enableSaveCard={true}
            setErrorPayment={setPaymentFailureData}
            onPaymentSuccess={() => setCurrent('success')}
            onPaymentFailure={() => setCurrent('failure')}
            title={fisheryData?.venue_name}
            headerContent={
              <p>
                <span className={'gSemiBold fs-19'}>Booking ID:</span>{' '}
                {bookingData?.public_id?.split('_')[1]}
              </p>
            }
            paymentExpiryTime={reservationExpiryTime}
            onClickCountdownEndedBack={() => {
              setReservationExpiryTime(Date.now());
              setCurrent('booking');
            }}
          />
        </div>
      )}
      {current === 'success' && (
        <div style={{ maxWidth: 1000, margin: 'auto' }}>
          <BookingSuccessScreen
            fisheryPublicId={fisheryId}
            bookingId={bookingData?.public_id}
            userId={bookingData?.user_id}
            isInsideWidget={false}
          />
        </div>
      )}
      {current === 'failure' && (
        <div style={{ maxWidth: 800, margin: 'auto' }}>
          <PaymentFailure
            headerContent={
              <p>
                <span className={'gSemiBold black'}>Booking ID:</span>{' '}
                {bookingData?.public_id?.split('_')[1]}
              </p>
            }
            errorPayment={paymentFailureData}
            retryPaymentButton={
              <Button
                className={
                  'sb-blue-bg gSemiBold br10 fs-20 white txt-center w-full pd-10 mg-top-10 h-fit antd-link-button-override'
                }
                onClick={() => {
                  setCurrent('payment');
                  // Show payment page again
                }}
              >
                &lt; Back to payment
              </Button>
            }
            paymentSuccessfulButton={
              <Button
                className={
                  'sb-blue-bg gSemiBold br10 fs-20 white txt-center w-full pd-10 mg-top-10 h-fit antd-link-button-override'
                }
                href={`/fishery/${fisheryId}`}

                //   onClick={() => {
                //     if (isInsideWidget) {
                //       sendWidgetMessage({ type: 'widgetCollapse' });
                //     } else {
                //       // use href -- do nothing here
                //     }
                //   }}
              >
                &lt; Back to profile
              </Button>
            }
          />
        </div>
      )}
    </>
  );
};

export default PackageBooking;
